import _ from 'root/libs/exaforte/react/lodash';
import Components from 'root/Components';
import Model from 'root/libs/exaforte/react/Model';
import CustomDate from 'root/libs/exaforte/react/CustomDate';
import { TimePeriodPlanningModel, RoutePlanningModel, RoutePlanningTaskModel, BlueprintBlockPlanningModel, SelfSchedulePlanningModel } from './PlanningModel';
import { Planning } from 'root/globals/Functions';
import Config from 'root/globals/Config';
import moment from 'moment';
import defaults from 'root/globals/Defaults.less';

import { ReminderTypes, NotificationTypes, DisabledCompensationLabels } from 'root/globals/planning/BlueprintBlockValues';

const today = new CustomDate().getYearMonthDay();

export default class PlannableModel extends Model {
    get_settings(settings) {
        return this.data;
    }
    
    is_plannable(settings) {
        settings = {...{user_id: null, relation_field: 'blueprint_block_id', check_if_planned: true, selfschedule: false, strict: false, atw_only: false, atw_should_give_error: false, check_self_schedules: true, message_subject: 'Medewerker'}, ...settings};
        
        if(!settings.data)
            settings.data = this.get_settings(settings);
        
        let messages            = {errors: [], warnings: []};
        let user                = settings.user || this.config.controller.get_data({models: [Components.__EMPLOYEE_COMPONENT__, Components.__SUBCONTRACTOR_COMPONENT__, Components.__SUBCONTRACTOR_EMPLOYEE_COMPONENT__], filter_field: {id: {value: settings.user_id}}, limit: 1});
        let user_contract       = settings.user_contract || this.config.controller.get_data({models: [Components.__CONTRACT_COMPONENT__], filter_field: {user_id: {value: user.id}, function_group_id: {value: model => _.is_empty(settings.data.function_group_id) || _.is_value_in_set(model.function_group_ids, settings.data.function_group_id), type: 'function'}, date: {type: 'function', value: model => settings.date >= model.start_date && settings.date <= _.if_empty(model.end_date, settings.date)}}, limit: 1});
        let planning_components = (settings.check_self_schedules ? [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, Components.__SELF_SCHEDULE_PLANNING_COMPONENT__] : [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__]);
        let planning_items;
        
        if(!settings.atw_only && user.component_id == Components.__EMPLOYEE_COMPONENT__)
        {
            if(_.is_empty(user_contract))
            {
                if(this.config.controller.component.state.periods && today < this.config.controller.component.state.periods[this.config.controller.component.state.current_period_id].start_date)
                    user_contract = this.config.controller.get_data({models: [Components.__CONTRACT_COMPONENT__], filter_field: {user_id: {value: user.id}, function_group_id: {value: model => _.is_empty(settings.data.function_group_id) || _.is_value_in_set(model.function_group_ids, settings.data.function_group_id), type: 'function'}, date: {type: 'function', value: model => today >= model.start_date && today <= _.if_empty(model.end_date, today)}}, limit: 1});
                
                if(_.is_empty(user_contract))
                {
                    if(_.is_empty(settings.data.function_group_id))
                        messages.errors.push('Medewerker heeft geen geldig contract voor het tijdvak op ' + _.get_date_format(settings.date));
                    else
                        messages.errors.push('Medewerker heeft geen geldig contract voor de functiegroep ' + this.config.controller.component.state.models[Components.__FUNCTION_GROUP_COMPONENT__][settings.data.function_group_id].title + ' op de dienst van ' + _.get_date_format(settings.date));
                }
            }
        }

        // Als er al een error is, hoef je de volgende dingen niet ook nog te checken.
        if(!settings.atw_only && !_.is_empty(settings.relation_field) && (settings.return_all_messages || _.size(messages.errors) == 0))
        {
            let filter_field                        = {};
            filter_field[settings.relation_field]   = {value: this.get_bind_id()}; // Moet functie zijn omdat tijdvakken geen relatie id hebben
            filter_field.date                       = {type: 'function', value: model => (_.get_date_format((model instanceof Model ? model.get_field_data('start_date_time') : model.start_date_time), true) == settings.date)};
            filter_field.user_id                    = {value: user.id};
            filter_field.removed                    = {value: 't', type: 'excludes'};
            planning_items                          = this.config.controller.get_data_and_models({models: planning_components, models_object: 'array', filter_field: filter_field, format: 'asGrouped', key: ['id']}); // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.

            // Onderaannemers worden als 1 bedrijf er in gezet, dus die mogen wel dubbel op een dienst ingepland worden
            if(user.component_id != Components.__SUBCONTRACTOR_COMPONENT__ && settings.check_if_planned && _.size(planning_items))
                messages.errors.push((settings.message_subject == '$self$' ? 'Je' : settings.message_subject) + ' staat al ingepland op de dienst van ' + _.get_date_format(settings.date));
        }
        
        // Als er al een error is, hoef je de volgende dingen niet ook nog te checken.
        if(!settings.atw_only && !_.is_empty(settings.relation_field) && (settings.return_all_messages || _.size(messages.errors) == 0) && !_.is_empty(this.get_field_data('relation_id')))
        {
            let filter_field                        = {};
            filter_field[settings.relation_field]   = {value: this.get_bind_id()}; // Moet functie zijn omdat tijdvakken geen relatie id hebben
            filter_field.date                       = {type: 'function', value: model => (_.get_date_format((model instanceof Model ? model.get_field_data('start_date_time') : model.start_date_time), true) == settings.date)};
            filter_field.user_id                    = {value: -1};
            let available_planning_items            = this.config.controller.get_data_and_models({models: [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__], filter_field: filter_field}); // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
            
            // Check of je een dienst niet teveel wilt inplannen.
            if(_.is_empty(available_planning_items))
                messages.errors.push('Je hebt al het maximaal aantal medewerkers ingepland op de dienst van ' + _.get_date_format(settings.date) + '. Als je meer medewerkers wilt inplannen moet de hoofdaannemer die eerst vrijgeven.');
        }
        
        if(settings.return_all_messages || _.size(messages.errors) == 0)
        {
            let restrictions;

            if(this instanceof BlueprintBlockModel)
                restrictions = this.config.controller.get_data({models: [Components.__CUSTOMER_EMPLOYEE_RESTRICTION_COMPONENT__, Components.__CUSTOMER_OBJECT_EMPLOYEE_RESTRICTION_COMPONENT__], filter_field: {user_id: {value: settings.user_id}, match: {type: 'function', value: model => model.customer_id == this.get_field_data('customer_id') && (_.is_empty(model.customer_object_id) || model.customer_object_id == this.get_field_data('customer_object_id'))}}, format: 'asGrouped', key: 'user_id', sort: [{ field: 'customer_object_id' }]});
            else
                restrictions = this.config.controller.get_data({ models: [Components.__ROUTE_EMPLOYEE_RESTRICTION_COMPONENT__], format: 'asGrouped', filter_field: { route_parent_id: { value: this.get_field_data('route_parent_id') }, user_id: {value: settings.user_id} }, key: 'user_id' });

            if(restrictions[settings.user_id] && restrictions[settings.user_id].is_allowed == 'f')
                messages.errors.push('Medewerker mag ' + (this instanceof BlueprintBlockModel ? 'op dit object'  : 'deze route') + ' niet werken.');
        }
        
        // TODO: medewerkers van onderaannemers mogen niet ingepland worden als de onderaannemer een relation_id heeft
        if(!settings.atw_only && user.component_id == Components.__SUBCONTRACTOR_EMPLOYEE_COMPONENT__ && (settings.return_all_messages || _.size(messages.errors) == 0))
        {
            let subcontractor = this.config.controller.get_data({models: [Components.__SUBCONTRACTOR_COMPONENT__], filter_field: {id: {value: user.subcontractor_id}}, limit: 1});
            
            if(!_.is_empty(subcontractor.relation_id))
                messages.errors.push('Je kunt deze medewerker niet inplannen op de dienst van ' + _.get_date_format(settings.date) + '. Je kunt alleen de onderaannemer ' + subcontractor.title + ' zelf inplannen omdat die gekoppeld staat aan hun eigen omgeving.');
        }

        if(settings.return_all_messages || _.size(messages.errors) == 0)
        {
            let current_start_date_time = _.get_datetime_format(settings.date + ' ' + settings.data.start_time, true) + ':00';
            let current_end_date_time   = CustomDate.getCustomDateTime(current_start_date_time);

            current_end_date_time.setMinutes(current_end_date_time.getMinutes() + _.time_to_minutes(settings.data.duration));

            // Onderaannemers worden als 1 bedrijf er in gezet, dus die mag wel overlap hebben.
            if(user.component_id != Components.__SUBCONTRACTOR_COMPONENT__ || user.type === 'ZZP')
            {
                const exclude_planning_items  = _.keys(planning_items);
                // let filter_field            = {user_id: {value: user.id}, id: {value: model => { let data = (model instanceof Model ? model.data : model); return data.component_id == Components.__SELF_SCHEDULE_PLANNING_COMPONENT__ || !exclude_planning_items.includes(data.id); }, type: 'function'}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => _.is_crossing_datetime_period((model instanceof Model ? model.get_field_data('start_date_time') : model.start_date_time), (model instanceof Model ? model.get_field_data('end_date_time') : model.end_date_time), current_start_date_time, current_end_date_time.getDateTime(true))}};
                const filter_field            = {user_id: {value: user.id}, id: {value: model => { let data = (model instanceof Model ? model.data : model); return data.component_id == Components.__SELF_SCHEDULE_PLANNING_COMPONENT__ || !exclude_planning_items.includes(data.id); }, type: 'function'}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => (model instanceof Model ? model.get_field_data('start_date_time') : model.start_date_time) < current_end_date_time.getDateTime(true) && current_start_date_time < (model instanceof Model ? model.get_field_data('end_date_time') : model.end_date_time) }, state: { value: 'Geannuleerd', type: 'excludes' }};
                const current_planning        = this.config.controller.get_data_and_models({models: planning_components, filter_field: filter_field, models_object: 'array'});

                if(_.size(current_planning) > 0)
                    messages[settings.strict ? 'errors' : 'warnings'].push((settings.message_subject == '$self$' ? 'Je' : settings.message_subject) + ' staat op ' + _.get_date_format(settings.date) + ' al ingepland op een andere dienst tijdens deze dienst.');
            }
            
            let current_start_date_time_date = CustomDate.getCustomDateTime(current_start_date_time);
            
            if(!settings.atw_only)
            {
                let has_performance_appraisal = this.config.controller.get_data({models: [Components.__PERFORMANCE_APPRAISAL_COMPONENT__], filter_field: {user_id: {value: user.id}, date_time_check: {value: model => (model.date + ' ' + model.start_time <= current_end_date_time.getDateTime(true) && model.date + ' ' + model.end_time >= current_start_date_time)}}});
    
                if(_.size(has_performance_appraisal) > 0)
                    messages[settings.strict ? 'errors' : 'warnings'].push((settings.message_subject == '$self$' ? 'Je hebt' : settings.message_subject + ' heeft') + ' een gesprek gepland op ' + _.get_date_format(settings.date) + ' van ' + _.get_time_format(has_performance_appraisal[0].start_time) + ' t/m ' + _.get_time_format(has_performance_appraisal[0].end_time) + '.');
    
                let has_leave_application = this.config.controller.get_data({models: [Components.__LEAVE_APPLICATION_COMPONENT__], filter_field: {user_id: {value: user.id}, date_check: {type: 'function', value: model => (settings.date >= model.start_date && settings.date <= model.end_date)}}});
                
                if(_.size(has_leave_application) > 0)
                    messages.warnings.push((settings.message_subject == '$self$' ? 'Je bent' : settings.message_subject + ' is') + ' op ' + _.get_date_format(settings.date) + ' met verlof.');
    
                let has_sickness_item = this.config.controller.get_data({models: [Components.__SICKNESS_REPORT_COMPONENT__], filter_field: {user_id: {value: user.id}, date_check: {type: 'function', value: model => (settings.date >= model.start_date && settings.date <= _.if_empty(model.end_date, settings.date))}}});
                    
                if(_.size(has_sickness_item) > 0)
                    messages.warnings.push((settings.message_subject == '$self$' ? 'Je bent' : settings.message_subject + ' is') + ' nog aangemerkt als ziek op ' + _.get_date_format(settings.date) + '.');
            
                // We moeten ook naar de dag van gisteren kijken. Want de dienst die vandaag wordt ingepland kan invloed hebben op een roostervrije dag van gisteren. Dit omdat de rusttijd van gisteren wordt aangepast als je vandaag een dienst inplant.
                let yesterday = CustomDate.getCustomDateTime(current_start_date_time);

                yesterday.setDate(yesterday.getDate() - 1);
                
                let schedule_free_days = this.config.controller.get_data({models: [Components.__PLANNING_USER_UNAVAILABILITY_SCHEDULE_FREE_COMPONENT__], filter_field: {user_id: {value: user.id}, removed: {value: 't', type: 'excludes'}, date_check: {type: 'function', value: model => (_.get_date_format(model.start_date_time, true) == current_start_date_time_date.getYearMonthDay() || _.get_date_format(model.start_date_time, true) == current_end_date_time.getYearMonthDay() || _.get_date_format(model.start_date_time, true) == yesterday.getYearMonthDay())}}});
    
                if(_.size(schedule_free_days) > 0)
                    for(let i in schedule_free_days)
                        if(!Planning.is_free_day({date: _.get_date_format(schedule_free_days[i].start_date_time, true), controller: this.config.controller, user_id: user.id, new_planning_item: {start_date_time: current_start_date_time, end_date_time: current_end_date_time.getDateTime(true)}}))
                            messages.warnings.push((settings.message_subject == '$self$' ? 'Je hebt' : settings.message_subject + ' heeft') + ' een roostervrije dag voor de dienst die start op ' + _.get_date_format(settings.date) + '. Als je ' + (settings.message_subject == '$self$' ? 'jezelf' : (settings.message_subject == 'Medewerker' ? 'deze medewerker' : settings.message_subject)) + ' inplant komt de roostervrije dag te vervallen.');
            }
            if(user.component_id == Components.__EMPLOYEE_COMPONENT__)
            {
                const atwMessageArray = settings.atw_should_give_error ? messages.errors : messages.warnings;
                // ATW, maximaal 60 uur per week werken
                let filter_field        = {user_id: {value: user.id}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => {
                                            let model_data  = (model instanceof Model ? model.data : model);
                                            let start_date  = CustomDate.getCustomDateTime(model_data.start_date_time);
                                            
                                            return start_date.getYearWeek() == current_start_date_time_date.getYearWeek();
                                        }}}
                let week_planning_items = this.config.controller.get_data_and_models({models: [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field});
                
                if(!_.is_empty(week_planning_items))
                {
                    let week_minutes = 0;

                    for(let i in week_planning_items)
                        week_minutes += moment(week_planning_items[i].end_date_time).diff(moment(week_planning_items[i].start_date_time), 'minutes');

                    if((week_minutes + _.time_to_minutes(settings.data.duration)) > (60*60))
                        atwMessageArray.push((settings.message_subject == '$self$' ? 'Je' : settings.message_subject) + ' mag maximaal 60 uur per week werken en gaat daar nu in week ' + current_start_date_time_date.getYearWeek().substring(4) + ' overheen.');
                }
                
                // AWT, na een werkdag mag een werknemer 11 uur aaneengesloten niet werken. Dus 11 uur op een dag moet je niet werken
                let rest_end_date_time = _.clone(current_end_date_time);

                rest_end_date_time.setHours(rest_end_date_time.getHours() + 11);
                rest_end_date_time.setSeconds(rest_end_date_time.getSeconds() - 1); // Omdat wanneer hij aansluitend is is_crossing_datetime_period een resultaat zal geven, terwijl je dan wel die rusttijd gehad hebt.
                
                filter_field.time.value = model => {
                    let model_data = (model instanceof Model ? model.data : model);
                    
                    // Als het een tijdvak is die binnen de dienst valt is het waarschijnlijk het tijdvak dat bedoeld is voor die dienst. Dan hoeven we hem dus niet mee te nemen in de controle
                    if(!_.is_empty(settings.data.function_group_id) && model_data.component_id == Components.__PLANNING_TIME_PERIOD_COMPONENT__ && _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, current_start_date_time, current_end_date_time.getDateTime(true)))
                        return false;

                    return _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, current_end_date_time.getDateTime(true), rest_end_date_time.getDateTime(true));
                };
                
                // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
                let next_planning_items = this.config.controller.get_data_and_models({models: [...planning_components, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field, models_object: 'array', sort: [{field: 'end_date_time', by: 'desc'}]});

                // Als er binnen 11 uur diensten zijn moeten we kijken of je wel genoeg rusttijd krijgt door deze dienst.
                if(!_.is_empty(next_planning_items))
                {
                    let last_planning_item  = next_planning_items[0];
                    let rest_end_date_time  = new CustomDate(last_planning_item.end_date_time);
                    
                    rest_end_date_time.setHours(rest_end_date_time.getHours() + 11);
                    rest_end_date_time.setSeconds(rest_end_date_time.getSeconds() - 1); // Omdat wanneer hij aansluitend is is_crossing_datetime_period een resultaat zal geven, terwijl je dan wel die rusttijd gehad hebt.
                    
                    filter_field.time.value = model => {
                        let model_data = (model instanceof Model ? model.data : model);
                        
                        // Als het een tijdvak is die binnen de dienst valt is het waarschijnlijk het tijdvak dat bedoeld is voor die dienst. Dan hoeven we hem dus niet mee te nemen in de controle
                        if(!_.is_empty(last_planning_item.function_group_id) && model_data.component_id == Components.__PLANNING_TIME_PERIOD_COMPONENT__ && _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, last_planning_item.start_date_time, last_planning_item.end_date_time))
                            return false;

                        return _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, last_planning_item.start_date_time, rest_end_date_time.getDateTime(true)) && model_data.id != last_planning_item.id;
                    };

                    let rest_time_check_planning_items = this.config.controller.get_data_and_models({models: [...planning_components, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field, models_object: 'array', sort: [{field: 'end_date_time', by: 'desc'}]});
                    
                    if(!_.is_empty(rest_time_check_planning_items))
                        atwMessageArray.push((settings.message_subject == '$self$' ? 'Je hebt' : settings.message_subject + ' heeft') + ' recht op een onafgebroken dagelijkse rusttijd van 11 uur volgens arbeidstijdenwet en komt daar op ' + _.get_date_format(settings.date) + ' niet aan.');
                }

                // AWT, maximaal 10 uur per dienst werken
                // if(_.time_to_minutes(settings.data.duration) > (10*60))
                //     messages.warnings.push((settings.message_subject == '$self$' ? 'Je' : settings.message_subject) + ' mag maximaal 10 uur per dienst werken volgens de arbeidstijdenwet.');
                
                // AWT nachtdienst
                // Als de dienst op de vorige dag begon valt de eindtijd in de nacht. Dus dan moeten we de einddatum gebruiken voor de bepaling of het een nachtdienst is.
                let date = (_.get_date_format(current_start_date_time) != current_end_date_time.getYearMonthDay() ? current_end_date_time.getYearMonthDay() : _.get_date_format(current_start_date_time, true));

                // Is een nachtdienst
                if(Planning.is_night_shift({date: date, start_date_time: current_start_date_time, end_date_time: current_end_date_time.getDateTime(true)}))
                {
                // > Artikel 28.5.1 en Artikel 28.5.2 =>  De werknemer heeft recht op rust na een nachtdienst
                    const rest_hours_after_shift = this.get_needed_rest_hours_after_night_shift({ ...settings, user_id: user.id, current_end_date_time, current_start_date_time, planning_items, planning_components });
                
                    if(!_.is_empty(rest_hours_after_shift))
                        atwMessageArray.push((settings.message_subject == '$self$' ? 'Je' : settings.message_subject) + ' krijgt nu geen onafgebroken rusttijd van ' + rest_hours_after_shift + ' uur op ' + _.get_date_format(settings.date) + '.');
                // > Artikel 28.5.3 =>  De werknemer die arbeid verricht in een reeks van aaneengesloten nachtdiensten heeft recht op een onafgebroken rusttijd van ten minste 48 uur. Een reeks is minimaal drie en maximaal 7 aaneengesloten nachtdiensten
                    const adjacent_night_shifts     = Planning.get_night_shift_serie({ ...settings, controller: this.config.controller, start_date_time: current_start_date_time, end_date_time: current_end_date_time, cao_id: user_contract.cao_id });
                    const rest_hours                = (user_contract.cao_id == 1 ? 48 : 46); 
                    const date_time                 = this.get_required_rest_date_time_from_shift_in_night_shift_chain({ ...settings, adjacent_night_shifts, rest_hours, current_start_date_time, current_end_date_time, planning_components });
                    
                    if(date_time !== undefined)
                        atwMessageArray.push('De werknemer die arbeid verricht in een reeks van aaneengesloten nachtdiensten heeft recht op een onafgebroken rusttijd van ten minste ' + rest_hours + ' uur op ' + _.get_date_format(date_time, true) + '.');
                
                    const last_shift_of_serie = this.get_shift_in_night_shift_rest_periode({ ...settings, controller: this.config.controller, start_date_time: current_start_date_time, rest_hours, previous_adjacent_night_shifts: adjacent_night_shifts.before.amount });
                    
                    if(!_.is_empty(last_shift_of_serie))
                        atwMessageArray.push('De werknemer die arbeid verricht in een reeks van aaneengesloten nachtdiensten heeft recht op een onafgebroken rusttijd van ten minste ' + rest_hours + ' uur op ' + _.get_date_format(last_shift_of_serie.start_date_time) + '.');

                // > Artikel 28.5.3 =>  Er mogen maximaal 7 aaneengesloten nachtdiensten ingeroosterd worden.
                    // == 7 omdat deze dienst zelf ook meetelt. Er mogen maximaal 7, dus geen 8.
                    if((adjacent_night_shifts.before.amount + adjacent_night_shifts.after.amount) == 7)
                        atwMessageArray.push((settings.message_subject == '$self$' ? 'Je' : settings.message_subject) + ' krijgt nu meer dan 7 aaneengesloten nachtdiensten op ' + _.get_date_format(settings.date) + '.');
                }
                else if(_.is_crossing_datetime_period(current_start_date_time, current_end_date_time.getDateTime(true), (settings.date + ' 06:00:00'), (settings.date + ' 19:59:59')))
                {
                    // > Artikel 33.6 => onafgebroken rusttijd van een nachtdienst op de dienst die daarop volgt
                        let filter_field = {user_id: {value: user.id}, id: {value: _.keys(planning_items), type: 'excludes_desc'}, state: { value: 'Geannuleerd', type: 'excludes' }, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => {
                            let model_data = (model instanceof Model ? model.data : model);
                            
                            // Als het een tijdvak is die binnen de dienst valt is het waarschijnlijk het tijdvak dat bedoeld is voor die dienst. Dan hoeven we hem dus niet mee te nemen in de controle
                            if(!_.is_empty(settings.data.function_group_id) && model_data.component_id == Components.__PLANNING_TIME_PERIOD_COMPONENT__ && _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, current_start_date_time, current_end_date_time.getDateTime(true)))
                                return false;

                            return _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, settings.date + ' 00:00:00', settings.date + ' 05:59:59');
                        }}};
                        
                        // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
                        let night_shift_planning_item = this.config.controller.get_data_and_models({models: [...planning_components, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field, models_object: 'array'});

                        for(let i in night_shift_planning_item)
                        {
                            let end_date_time = CustomDate.getCustomDateTime(night_shift_planning_item[i].end_date_time);
                            
                            // De werknemer heeft na een nachtdienst die eindigt na 02.00 uur recht op een onafgebroken rusttijd van ten minste 14 uur
                            let rest_hours = 14;
                            
                            // De werknemer heeft na een nachtdienst die eindigt vóór 02.00 uur recht op een onafgebroken rusttijd van ten minste 11 uur. 
                            if(end_date_time.getTimeText(true) < '02:00:00')
                                rest_hours = 11;
                            
                            let rest_end_date_time = _.clone(end_date_time);
                            rest_end_date_time.setHours(rest_end_date_time.getHours() + rest_hours);

                            if(rest_end_date_time.getDateTime(true) > _.get_datetime_format(current_start_date_time, true)) // > omdat wanneer hij aansluitend is is_crossing_datetime_period een resultaat zal geven, terwijl je dan wel die rusttijd gehad hebt.
                                atwMessageArray.push((settings.message_subject == '$self$' ? 'Je' : settings.message_subject) + ' krijgt nu geen onafgebroken rusttijd van ' + rest_hours + ' uur op ' + _.get_date_format(settings.date) + '.');
                        }
                    // > Artikel 33.7.1 =>  De werknemer die arbeid verricht in een reeks van aaneengesloten nachtdiensten heeft recht op een onafgebroken rusttijd van ten minste 48 uur. Een reeks is minimaal drie en maximaal 7 aaneengesloten nachtdiensten
                    let adjacent_night_shift_count  = 0;
                    let check_date                  = new CustomDate(date);
                    
                    loop:
                    for(let i = 0;i < 3;i++)
                    {
                        check_date.setDate(check_date.getDate() - 1);
                
                        // De diensten ophalen die in de nacht vallen van deze datum
                        let filter_field = {user_id: {value: user.id}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => {
                            let model_data = (model instanceof Model ? model.data : model);
                            
                            // Als het een tijdvak is die binnen de dienst valt is het waarschijnlijk het tijdvak dat bedoeld is voor die dienst. Dan hoeven we hem dus niet mee te nemen in de controle
                            if(!_.is_empty(settings.data.function_group_id) && model_data.component_id == Components.__PLANNING_TIME_PERIOD_COMPONENT__ && _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, current_start_date_time, current_end_date_time.getDateTime(true)))
                                return false;

                            return _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, check_date.getYearMonthDay() + ' 00:00:00', check_date.getYearMonthDay() + ' 05:59:59');
                        }}};
                        
                        // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
                        let adjacent_night_planning = this.config.controller.get_data_and_models({models: [...planning_components, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field, models_object: 'array'});

                        if(_.size(adjacent_night_planning) != 0)
                        {
                            let rest_hours = (user_contract.cao_id == 1 ? 48 : 46);

                            for(let i in adjacent_night_planning)
                                if(Planning.is_night_shift({date: check_date.getYearMonthDay(), start_date_time: adjacent_night_planning[i].start_date_time, end_date_time: adjacent_night_planning[i].end_date_time}))
                                {
                                    let adjacent_night_shifts       = Planning.get_night_shift_serie({controller: this.config.controller, id: adjacent_night_planning[i].id, component_id: adjacent_night_planning[i].component_id, user_id: user.id, start_date_time: adjacent_night_planning[i].start_date_time, end_date_time: adjacent_night_planning[i].end_date_time});
                                    let minutes_between_date_times  = CustomDate.getCustomDateTime(adjacent_night_planning[i].end_date_time).getDiff({date_time: current_start_date_time});

                                    // Een reeks is 3 of meer nachtdiensten en je hebt dan 48 uur rust
                                    if(adjacent_night_shifts.before.amount >= 2 && minutes_between_date_times < (rest_hours*60))
                                        atwMessageArray.push('De werknemer die arbeid verricht in een reeks van aaneengesloten nachtdiensten heeft recht op een onafgebroken rusttijd van ten minste ' + rest_hours + ' uur op ' + _.get_date_format(adjacent_night_planning[i].end_date_time) + '.');
                                    
                                    break loop;
                                }
                        }
                    }
                }
                
                if(user_contract.cao_id == 1 || user_contract.cao_id == 3)
                {
                    // TODO: ARTIKEL 21 INROOSTEREN => Het rooster bevat per loonperiode minimaal 8 vrije dagen waarvan minimaal 2 periodes van twee aaneengesloten vrije dagen waarvan minimaal 1 een weekend betreft waar geen arbeid wordt verricht
                    
                    // Ook op maandag, want de dienst van de maandag kan invloed hebben op de rusttijd die je op de zondag gehad hebt.
                    if(current_start_date_time_date.getDayNumber() == 0 || current_start_date_time_date.getDayNumber() == 5 || (current_end_date_time.getDayNumber() == 5 && !Planning.is_free_day({date: current_end_date_time.getYearMonthDay(), controller: this.config.controller, user_id: user.id, new_planning_item: {start_date_time: current_start_date_time, end_date_time: current_end_date_time.getDateTime(true)}})) || current_start_date_time_date.getDayNumber() == 6 || current_end_date_time.getDayNumber() == 6)
                    {
                        let filter_field = {user_id: {value: user.id}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => {
                            let model_data  = (model instanceof Model ? model.data : model);
                            let start_date  = CustomDate.getCustomDateTime(model_data.start_date_time);
                            let end_date    = CustomDate.getCustomDateTime(model_data.end_date_time);
                            
                            return start_date.getDayNumber() == 5 || (end_date.getDayNumber() == 5 && !Planning.is_free_day({date: end_date.getYearMonthDay(), controller: this.config.controller, user_id: user.id, new_planning_item: {start_date_time: current_start_date_time, end_date_time: current_end_date_time.getDateTime(true)}})) || start_date.getDayNumber() == 6 || end_date.getDayNumber() == 6;
                        }}}
                        
                        // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
                        let weekend_planning_items = this.config.controller.get_data_and_models({models: [...planning_components, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field, format: models => {
                            let formatted_data = {};
    
                            for(let i in models)
                            {
                                let start_date = _.get_date_format(models[i].start_date_time, true);
                                
                                if(start_date < this.config.controller.component.state.periods[this.config.controller.component.state.current_period_id].start_date || start_date > this.config.controller.component.state.periods[this.config.controller.component.state.current_period_id].end_date)
                                    continue;
                                
                                start_date      = CustomDate.getCustomDateTime(models[i].start_date_time);
                                let end_date    = CustomDate.getCustomDateTime(models[i].end_date_time);
                                
                                if(start_date.getDayNumber() == 5 || start_date.getDayNumber() == 6)
                                    formatted_data[start_date.getYearWeek()] = start_date.getYearWeek();
                                else if((end_date.getDayNumber() == 5 && end_date.getTimeText(false) != '00:00') || end_date.getDayNumber() == 6)
                                    formatted_data[end_date.getYearWeek()] = end_date.getYearWeek();
                            }
                            
                            return formatted_data;
                        }, models_object: 'array'});
                        
                        // De huidig in te plannen dag moet er ook nog bij.
                        if(current_start_date_time_date.getDayNumber() == 5 || current_start_date_time_date.getDayNumber() == 6)
                            weekend_planning_items[current_start_date_time_date.getYearWeek()] = current_start_date_time_date.getYearWeek();
                        else
                            weekend_planning_items[current_end_date_time.getYearWeek()] = current_end_date_time.getYearWeek();

                        let weekends = 4;
                        
                        // Als je niet 4 wekelijks plant moeten we kijken hoeveel weekenden er in deze periode zitten.
                        if(this.config.controller.component.state.period_type_id != 3)
                        {
                            let weekend_days    = 0;
                            let curDate         = new CustomDate(this.config.controller.component.state.periods[this.config.controller.component.state.current_period_id].start_date);
                            
                            while(curDate.getYearMonthDay() <= this.config.controller.component.state.periods[this.config.controller.component.state.current_period_id].end_date)
                            {
                                if(curDate.getDay() == 0 || curDate.getDay() == 6)
                                    weekend_days++;
                                
                                curDate.setDate(curDate.getDate() + 1);
                            }
    
                            weekends = Math.floor(weekend_days/2);
                        }

                        if(weekends > 1 && _.size(weekend_planning_items) == weekends)
                            atwMessageArray.push((settings.message_subject == '$self$' ? 'Je hebt' : settings.message_subject + ' heeft') + ' recht op ten minste 1 vrij weekend per periode.');
                    }
                    
                    // TODO: ARTIKEL 25 OVERWERK => De werknemer is verplicht overwerk te verrichten, indien dat in het belang van de onderneming noodzakelijk is. Daarbij geldt een maximaal aantal arbeidsuren van 160 per loonperiode.
                    
                    // TODO: ARTIKEL 30 DAGELIJKSE ONAFGEBROKEN RUSTTIJD => De werknemer heeft recht op een dagelijkse onafgebroken rusttijd van ten minste 11 uur in een periode van 24 uur. In afwijking van de arbeidstijdenwet is het niet toegestaan deze rusttijd in te korten.
                    // let dayly_rest_end_date_time = _.clone(current_end_date_time);
                    // dayly_rest_end_date_time.setHours(dayly_rest_end_date_time.getHours() + 11);
                    // dayly_rest_end_date_time.setSeconds(dayly_rest_end_date_time.getSeconds() - 1); // Omdat wanneer hij aansluitend is is_crossing_datetime_period een resultaat zal geven, terwijl je dan wel die rusttijd gehad hebt.
    
                    // let filter_field = {user_id: {value: user.id}, id: {value: _.keys(planning_items), type: 'excludes_desc'}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => {
                    //     let model_data = (model instanceof Model ? model.data : model);
    
                    //     return _.is_crossing_period(_.get_date_format(model_data.start_date_time, true), _.get_date_format(model_data.end_date_time, true), _.get_date_format(current_start_date_time, true), dayly_rest_end_date_time.getYearMonthDay());
                    // }}};
                    
                    // // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
                    // let day_planning_items = this.config.controller.get_data_and_models({models: [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field});
    
                    // ARTIKEL 27.2 WEKELIJKSE ONAFGEBROKEN RUSTTIJD => De werknemer heeft recht op een wekelijkse onafgebroken rusttijd van: 
                    // - ten minste 36 uren in elke periode van 7 maal 24 uur, of 
                    // - ten minste 72 uren in elke periode van 14 maal 24 uren; Deze rusttijd mag worden opgesplitst in perioden van minimaal 32 uur.
                    const has_biweekly_rest_72h_violation   = this.has_sliding_window_violation({ ...settings, user_id: user.id, current_end_date_time, current_start_date_time, planning_items, planning_components, windowHours: 13 * 24, requiredRestHours: 72, minAllowedRest: 32 });
                    
                    if(has_biweekly_rest_72h_violation)
                        atwMessageArray.push((settings.message_subject == '$self$' ? 'Je hebt' : settings.message_subject + ' heeft') + ' recht op ten minste 72 uur onafgebroken rust per periode van 14 x 24 uur op ' + _.get_date_format(current_start_date_time));
                    else {
                        const has_weekly_rest_36h_violation     = this.has_sliding_window_violation({ ...settings, user_id: user.id, current_end_date_time, current_start_date_time, planning_items, planning_components, windowHours: 6 * 24, requiredRestHours: 36, minAllowedRest: null });
                        
                        if(has_weekly_rest_36h_violation)
                            atwMessageArray.push((settings.message_subject == '$self$' ? 'Je hebt' : settings.message_subject + ' heeft') + ' recht op ten minste 36 uur onafgebroken rust per periode van 7 x 24 uur op ' + _.get_date_format(current_start_date_time));
                    };
                    
                    // TODO: Artikel 32 ZONDAGARBEID => De werknemer heeft recht op ten minste 16 vrije zondagen per jaar waarop geen arbeid wordt verricht. Per loonperiode moet ten minste 1 vrije zondag worden vastgesteld, mede in het kader van het vrije weekend zoals bedoeld in artikel 21 lid 1.
    
                    // Ook op maandag, want de dienst van de maandag kan invloed hebben op de rusttijd die je op de zondag gehad hebt.
                    if(current_start_date_time_date.getDayNumber() == 0 || current_start_date_time_date.getDayNumber() == 6 || (current_end_date_time.getDayNumber() == 6 && !Planning.is_free_day({date: current_end_date_time.getYearMonthDay(), controller: this.config.controller, user_id: user.id, new_planning_item: {start_date_time: current_start_date_time, end_date_time: current_end_date_time.getDateTime(true)}})))
                    {
                        let filter_field = {user_id: {value: user.id}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => {
                            let model_data = (model instanceof Model ? model.data : model);
                            
                            return CustomDate.getCustomDateTime(model_data.start_date_time).getDayNumber() == 6 || CustomDate.getCustomDateTime(model_data.end_date_time).getDayNumber() == 6;
                        }}}
                        
                        // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
                        let sunday_planning_items = this.config.controller.get_data_and_models({models: [...planning_components, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field: filter_field, format: models => {
                            let formatted_data = {};
    
                            for(let i in models)
                            {
                                if(_.get_date_format(models[i].start_date_time, true) < this.config.controller.component.state.periods[this.config.controller.component.state.current_period_id].start_date || _.get_date_format(models[i].start_date_time, true) > this.config.controller.component.state.periods[this.config.controller.component.state.current_period_id].end_date)
                                    continue;
                                
                                if(CustomDate.getCustomDateTime(models[i].start_date_time).getDayNumber() == 6)
                                    formatted_data[_.get_date_format(models[i].start_date_time, true)] = _.get_date_format(models[i].start_date_time, true);
                                else if(CustomDate.getCustomDateTime(models[i].end_date_time).getDayNumber() == 6 && !Planning.is_free_day({date: _.get_date_format(models[i].end_date_time, true), controller: this.config.controller, user_id: user.id, new_planning_item: {start_date_time: current_start_date_time, end_date_time: current_end_date_time.getDateTime(true)}}))
                                    formatted_data[_.get_date_format(models[i].end_date_time, true)] = _.get_date_format(models[i].end_date_time, true);
                            }
                            
                            return formatted_data;
                        }, models_object: 'array'});
    
                        // De huidig in te plannen dag moet er ook nog bij.
                        if(current_start_date_time_date.getDayNumber() == 6)
                            sunday_planning_items[current_start_date_time_date.getYearMonthDay()] = current_start_date_time_date.getYearMonthDay();
                        else if(current_start_date_time_date.getDayNumber() == 5)
                            sunday_planning_items[current_end_date_time.getYearMonthDay()] = current_end_date_time.getYearMonthDay();
    
                        if(_.size(sunday_planning_items) == 4)
                            atwMessageArray.push((settings.message_subject == '$self$' ? 'Je hebt' : settings.message_subject + ' heeft') + ' recht op ten minste 1 vrije zondag per periode.');
                    }
                }
            }
            
            if(!settings.data)
                settings.data = Planning.get_blueprint_block_data_for_date({controller: this.config.controller, blueprint_block_id: this.get_bind_id(), date: settings.date});
            
            if(this.data.component_id == Components.__BLUEPRINT_BLOCK_COMPONENT__ || this.data.component_id == Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__)
            {
                if(!_.is_empty(settings.data.diploma_type_ids)) 
                {
                    let diploma_type_ids    = settings.data.diploma_type_ids ? settings.data.diploma_type_ids.toString().split(',') : [];
                    let diplomas            = settings.diplomas || this.config.controller.get_data({models: [Components.__DIPLOMA_COMPONENT__], format: 'asGrouped', key: 'diploma_type_id', filter_field: {user_id: {value: settings.user_id}, end_date: {value: model => ((_.is_empty(model.end_date) || model.end_date >= settings.date)), type: 'function'}}});
                    let diploma_types       = settings.diploma_types || this.config.controller.get_data({models: [Components.__DIPLOMA_TYPE_COMPONENT__], format: 'asGrouped', key: 'id', filter_field: {id: {value: diploma_type_ids, type: 'includes_desc'}}, sort: [{field: 'title'}]});
                    let missing             = [];

                    for(let i in diploma_type_ids)
                        if(!diplomas[diploma_type_ids[i]] && diploma_types[diploma_type_ids[i]])
                            missing.push(diploma_types[diploma_type_ids[i]].title);

                    if(!_.is_empty(missing))
                        messages[settings.strict ? 'errors' : 'warnings'].push((settings.message_subject == '$self$' ? 'Je hebt' : (settings.message_subject == 'Medewerker' ? 'De medewerker' : settings.message_subject) + ' heeft') + ' de volgende verplichte diploma\'s niet: ' + missing.join(', ') + '.');
                }
            }
            
            if(!_.is_empty(settings.data.security_pass_types))
            {
                let security_pass = this.config.controller.get_data({models: [Components.__SECURITY_PASS_COMPONENT__], filter_field: {user_id: {value: user.id}, type: {value: settings.data.security_pass_types, type: 'includes_desc'}, company_id: {value: model => (user.component_id != Components.__EMPLOYEE_COMPONENT__ || _.if_empty(model.company_id, user_contract.company_id) == user_contract.company_id)}, date: {type: 'function', value: model => settings.date >= model.start_date && settings.date <= _.if_empty(model.end_date, settings.date)}}, limit: 1});
                
                if(_.is_empty(security_pass))
                {
                    if(this.config.controller.component.state.periods && today < this.config.controller.component.state.periods[this.config.controller.component.state.current_period_id].end_date)
                        security_pass = this.config.controller.get_data({models: [Components.__SECURITY_PASS_COMPONENT__], filter_field: {user_id: {value: user.id}, type: {value: settings.data.security_pass_types, type: 'includes_desc'}, company_id: {value: model => (user.component_id != Components.__EMPLOYEE_COMPONENT__ || _.if_empty(model.company_id, user_contract.company_id) == user_contract.company_id)}, date: {type: 'function', value: model => today >= model.start_date && today <= _.if_empty(model.end_date, today)}}, limit: 1});

                    let company = this.config.controller.get_data({models: [Components.__COMPANY_COMPONENT__], filter_field: {id: {value: user_contract.company_id}}, limit: 1});

                    if(_.is_empty(security_pass))
                        messages[settings.strict ? 'errors' : 'warnings'].push((settings.message_subject == '$self$' ? 'Je hebt' : (settings.message_subject == 'Medewerker' ? 'De medewerker' : settings.message_subject) + ' heeft') + ' geen geldige beveiligingspas' + (!_.is_empty(company) ? ', voor het bedrijf ' + company.title + ',' : '') + ' met type ' + settings.data.security_pass_types.replace(/,/g, ' of ') + ' op ' + _.get_date_format(settings.date) + '. Deze pas is verplicht bij deze dienst.');
                }
            }
            
            if(!settings.unavailabilities)
                settings.unavailabilities = this.config.controller.get_data({models: [Components.__PLANNING_USER_UNAVAILABILITY_COMPONENT__], filter_field: {user_id: {value: settings.user_id}, date_time_check: {type: 'function', value: model => _.is_crossing_datetime_period(current_start_date_time_date.getDateTime(), current_end_date_time.getDateTime(), model.start_date_time, model.end_date_time)}, removed: {value: 't', type: 'excludes'}}});
            else
                settings.unavailabilities = _.filter(settings.unavailabilities, unavailability => _.is_crossing_datetime_period(unavailability.start_date_time, unavailability.end_date_time, current_start_date_time_date.getDateTime(), current_end_date_time.getDateTime()));
            
            if(!_.is_empty(settings.unavailabilities))
                messages.warnings.push((settings.message_subject == '$self$' ? 'Je bent' : (settings.message_subject == 'Medewerker' ? 'De medewerker' : settings.message_subject) + ' is') + ' niet beschikbaar op ' + _.get_date_format(settings.date) + '.');
        }

        return messages;
    }
    
    is_active_week(settings) {
        return true;
    }
    
    cao_check() {
        
    }
    
    // > Artikel 28.5.1 en Artikel 28.5.2 =>  De werknemer heeft recht op rust na een nachtdienst
    get_needed_rest_hours_after_night_shift(settings) {
        // Artikel 28.5.2 => De werknemer heeft na een nachtdienst die eindigt na 02.00 uur recht op een onafgebroken rusttijd van ten minste 14 uur
        let rest_hours = 14;
        
        // Artikel 28.5.1 => De werknemer heeft na een nachtdienst die eindigt vóór 02.00 uur recht op een onafgebroken rusttijd van ten minste 11 uur. 
        if(settings.current_end_date_time.getTimeText(true) < '02:00:00')
            rest_hours = 11;
            
        const rest_start_date_time = CustomDate.getCustomDateTime(settings.current_start_date_time);
        rest_start_date_time.setHours(rest_start_date_time.getHours() - rest_hours);
        rest_start_date_time.setSeconds(rest_start_date_time.getSeconds() + 1); // Omdat wanneer hij aansluitend is is_crossing_datetime_period een resultaat zal geven, terwijl je dan wel die rusttijd gehad hebt.
            
        const rest_end_date_time = _.clone(settings.current_end_date_time);
        rest_end_date_time.setHours(rest_end_date_time.getHours() + rest_hours);
        rest_end_date_time.setSeconds(rest_end_date_time.getSeconds() - 1); // Omdat wanneer hij aansluitend is is_crossing_datetime_period een resultaat zal geven, terwijl je dan wel die rusttijd gehad hebt.
        
        const filter_field = {user_id: {value: settings.user_id }, id: {value: _.keys(settings.planning_items), type: 'excludes_desc'}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => {    
            const model_data = (model instanceof Model ? model.data : model);
            
            // Als het een tijdvak is die binnen de dienst valt is het waarschijnlijk het tijdvak dat bedoeld is voor die dienst. Dan hoeven we hem dus niet mee te nemen in de controle
            if(!_.is_empty(settings.data.function_group_id) && model_data.component_id == Components.__PLANNING_TIME_PERIOD_COMPONENT__ && _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, settings.current_start_date_time, settings.current_end_date_time.getDateTime(true)))
                return false;
                
            const violates_before_rest = _.is_crossing_datetime_period(
                model_data.start_date_time,
                model_data.end_date_time,
                rest_start_date_time.getDateTime(true),
                settings.current_start_date_time
            );
                
            const violates_after_rest = _.is_crossing_datetime_period(
                model_data.start_date_time,
                model_data.end_date_time,
                settings.current_end_date_time.getDateTime(true),
                rest_end_date_time.getDateTime(true)
            );

            return violates_after_rest || violates_before_rest;
        }}}
        
        // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
        const adjacent_planning_items = this.config.controller.get_data_and_models({ models: [...settings.planning_components, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field, models_object: 'array' });
        
        return _.size(adjacent_planning_items) > 0 ? rest_hours : null;
    }
    
    // > Artikel 28.5.3 =>  De werknemer die arbeid verricht in een reeks van aaneengesloten nachtdiensten heeft recht op een onafgebroken rusttijd van ten minste 48 uur. Een reeks is minimaal drie en maximaal 7 aaneengesloten nachtdiensten
    // Controleren of er een dienst is die in de rust periode valt van de huidige reeks (indien die er is)
    get_required_rest_date_time_from_shift_in_night_shift_chain(settings) {
        // < 2 omdat de dienst zelf ook meetelt.
        if (settings.adjacent_night_shifts.before.amount + settings.adjacent_night_shifts.after.amount < 2)
            return;

        const chain_end_date_time   = CustomDate.getCustomDateTime(settings.adjacent_night_shifts.after.date_time);
        const rest_start_time       = chain_end_date_time.getDateTime(true);
        const rest_end_time         = CustomDate.getCustomDateTime(chain_end_date_time);
        
        rest_end_time.setHours(chain_end_date_time.getHours() + settings.rest_hours);
        rest_end_time.setSeconds(chain_end_date_time.getSeconds() - 1);

        const filter_field = {user_id: {value: settings.user_id}, removed: {value: 't', type: 'excludes'}, id: { value: model => { let data = (model instanceof Model ? model.data : model); return !(data.component_id == settings.adjacent_night_shifts.after.component_id && data.id == settings.adjacent_night_shifts.after); } }, time: {type: 'function', value: model => {
            const model_data = (model instanceof Model ? model.data : model);
            
            // Als het een tijdvak is die binnen de dienst valt is het waarschijnlijk het tijdvak dat bedoeld is voor die dienst. Dan hoeven we hem dus niet mee te nemen in de controle
            if(!_.is_empty(settings.data.function_group_id) && model_data.component_id == Components.__PLANNING_TIME_PERIOD_COMPONENT__ && _.is_crossing_datetime_period(model_data.start_date_time, model_data.end_date_time, settings.current_start_date_time, settings.current_end_date_time.getDateTime(true)))
                return false;
            
            // In het geval dat er een dienst midden in een reeks wordt gepland dan telt de dienst die erna al staat ingepland natuurlijk ook voor de reeks (Dit verstoord dus de rust niet, dus hoeft hij niet meegegeven te worden).
            if(model_data.end_date_time == rest_start_time)
                return false;    
                
            return _.is_crossing_datetime_period(
                model_data.start_date_time,
                model_data.end_date_time,
                rest_start_time,
                rest_end_time.getDateTime(true)
            );
        }}, state: { value: 'Geannuleerd', type: 'excludes' }};
        
        // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.
        const adjacent_planning = this.config.controller.get_data_and_models({models: [...settings.planning_components, Components.__PLANNING_TIME_PERIOD_COMPONENT__], filter_field });

        if(_.size(adjacent_planning) == 0)
            return;
            
        return settings.adjacent_night_shifts.after.date_time;
    }
    
    // > Artikel 28.5.3 =>  De werknemer die arbeid verricht in een reeks van aaneengesloten nachtdiensten heeft recht op een onafgebroken rusttijd van ten minste 48 uur. Een reeks is minimaal drie en maximaal 7 aaneengesloten nachtdiensten
    // Controleren of de huidige dienst in een rust periode van een reeks valt (indien die er is)
    get_shift_in_night_shift_rest_periode(settings) {
        // Als er 2 of meer aanliggende nachtdiensten zijn betekent dat dat de in te plannen dienst deel uitmaakt van de reeks en dus niet in de rustperiode valt.
        if(settings.previous_adjacent_night_shifts >= 2)
            return;
        
        const previous_night_shifts = Planning.get_previous_night_shifts(settings);
        
        if(previous_night_shifts.length <= 2)
            return;
                    
        // Er zijn 3 of meer nachtdiensten geweest in de afgelopen 5 dagen voorafgaand op de in te plannen dienst
        // Controleren of de in te plannen dienst in de rusttijd ligt die na een reeks van minimaal 3 en maximaal 7 nachtdiensten verplicht is
        const last_shift            = previous_night_shifts[previous_night_shifts.length - 1];
        const last_shift_end        = moment(last_shift.end_date_time);
        const current_shift_start   = moment(settings.start_date_time);
    
        // Rusttijden afhankelijk van cao
        const diff_hours = current_shift_start.diff(last_shift_end, 'hours');
    
        // Er zit voldoende rusttijd tussen de diensten
        if (diff_hours >= settings.rest_hours)
            return;
            
        // Check op minimaal 3 opeenvolgende nachtdiensten
        const start_times       = previous_night_shifts.map(s => moment(s.start_date_time));
        let consecutive_count   = 1;
        let last_shift_of_serie = null;
        
        for (let i = 1; i < start_times.length; i++) {
            if (start_times[i].diff(start_times[i - 1], 'hours') <= 24) {
                consecutive_count++;
                
                if (consecutive_count >= 3)
                    last_shift_of_serie = previous_night_shifts[i]; // laatste van de huidige reeks
            } else
                consecutive_count = 1;
        }
        
        return last_shift_of_serie;
    }
    
    // ARTIKEL 27.2 WEKELIJKSE ONAFGEBROKEN RUSTTIJD => De werknemer heeft recht op een wekelijkse onafgebroken rusttijd van: 
    // - ten minste 36 uren in elke periode van 7 maal 24 uur;
    // - ten minste 72 uren in elke periode van 14 maal 24 uren; Deze rusttijd mag opgesplitst worden in perioden van minimaal 32 uur
    has_sliding_window_violation(settings) {
        const stepHours = 24;
        const hourInMs  = 3600000;
    
        const currentStart  = CustomDate.getCustomDateTime(settings.current_start_date_time);
        const currentEnd    = CustomDate.getCustomDateTime(settings.current_end_date_time);
        const earliest      = new Date(currentStart.getTime() - settings.windowHours * hourInMs);
        const latest        = new Date(currentEnd.getTime() + settings.windowHours * hourInMs);
    
        let cursorStart = new Date(earliest);
    
        while (cursorStart.getTime() + settings.windowHours * hourInMs <= latest.getTime()) {
            const cursorEnd = CustomDate.getCustomDateTime(cursorStart.getTime() + settings.windowHours * hourInMs);
    
            const hasEnoughRest = this.has_sufficient_rest_in_window({ ...settings, windowStart: CustomDate.getCustomDateTime(cursorStart), windowEnd: cursorEnd });
    
            if (!hasEnoughRest)
                return true;
    
            cursorStart.setHours(cursorStart.getHours() + stepHours);
        }
    
        return false;
    }
    
    has_sufficient_rest_in_window(settings) {
        if(!settings.minAllowedRest)
            settings.minAllowedRest = settings.requiredRestHours;
            
        const hourInMilliseconds    = 3600000;
        const filter_field          = {
            user_id : { value: settings.user_id },
            id      : { value: _.keys(settings.planning_items), type: 'excludes_desc' },
            removed : { value: 't', type: 'excludes' },
            time    : {
                type: 'function',
                value: model => {
                    const model_data = (model instanceof Model ? model.data : model);
    
                    return _.is_crossing_datetime_period(
                        model_data.start_date_time,
                        model_data.end_date_time,
                        settings.windowStart.getDateTime(true),
                        settings.windowEnd.getDateTime(true)
                    );
                }
            }
        };
    
        const items = this.config.controller.get_data_and_models({
            models: [
                ...settings.planning_components,
                Components.__PLANNING_TIME_PERIOD_COMPONENT__
            ],
            filter_field,
            models_object: 'array',
            sort: [{ field: 'start_date_time' }]
        });
    
        let cursor                  = settings.windowStart.getTime();
        let accumulatedRestHours    = 0;
    
        // Rust tussen alle diensten
        items.forEach(item => {
            const start = new Date(item.start_date_time).getTime();
            const end   = new Date(item.end_date_time).getTime();
    
            if (start > cursor) {
                const restHours = (start - cursor) / hourInMilliseconds;
                
                if (restHours >= settings.minAllowedRest)
                    accumulatedRestHours += restHours;
            }
    
            cursor = Math.max(cursor, end);
        });
        
        // Rust ná de laatste dienst tot einde venster
        if (cursor < settings.windowEnd.getTime()) {
            const restHours = (settings.windowEnd.getTime() - cursor) / hourInMilliseconds;
    
            if (restHours >= settings.minAllowedRest)
                accumulatedRestHours += restHours;
        }
    
        return accumulatedRestHours >= settings.requiredRestHours;
    }
}

export class BlueprintBlockModel extends PlannableModel {
    constructor(config)
    {
        super(config);
        
        this.linked_fields                                                          = {};
        this.linked_fields[Components.__PLANNING_COMPONENT__]                       = ['state', 'start_time', 'duration', 'customer_contract_arrangement_id', 'report_template_ids', 'function_group_id'];
        this.linked_fields[Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__]   = ['state', 'start_time', 'duration', 'customer_contract_arrangement_id', 'report_template_ids', 'function_group_id'];
    }
    
    reset(config)
    {
        config.data = {...{fielddefine_id: 10028, structure_id: (config.name == Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__ ? 10070 : 10028)}, ...config.data};
        
        super.reset(config);
    }
    
    get_settings(settings) {
        return Planning.get_blueprint_block_data_for_date({ controller: this.config.controller, blueprint_block: this.data, date: settings.date });
    }
    
    is_plannable(settings) {
        if(!settings.data)
            settings.data = this.get_settings(settings);
        
        let messages = super.is_plannable(settings);

        if(settings.remove_current)
            return messages;
        
        if(!settings.atw_only && _.is_empty(settings.data.relation_id))
        {
            let planned_shifts = this.config.controller.get_data({ models: [Components.__PLANNING_COMPONENT__, Components.__SELF_SCHEDULE_PLANNING_COMPONENT__], models_object: 'array', filter_field: { blueprint_block_id: { value: this.get_field_data('id') }, user_id: { value: -1, type: 'excludes' }, date: { value: model => _.get_date_format(model.start_date_time, true) == settings.date }, removed: {value: 't', type: 'excludes'} } });
    
            if(_.size(planned_shifts) == settings.data.user_amount)
                messages[(settings.selfschedule ? 'errors' : 'warnings')].push('Wanneer je deze medewerker inplant, zal de dienst bezet zijn door meer mensen dan je hebt opgegeven.');
        }
        
        return messages;
    }
    
    is_active_week(settings) {
        settings = {...{}, ...settings};

        if(!settings.data)
            settings.data = this.get_settings(settings);

        return Planning.is_active_week({setting_start_date: settings.data.setting_start_date, shift_date: settings.date, frequency: settings.data.frequency});
    }
    
    plan(settings) {
        let data        = settings.data || this.get_settings(settings);
        settings        = {...{user_id: null, remove_current: (_.format_input(data.user_amount) == 1 && _.is_empty(data.relation_id)), show_messages: true, apply_data_to_state: true, selfschedule: false}, ...settings};
        let user_id     = settings.user_id || settings.user.id;
        let messages    = (_.is_empty(settings.route_planning_id) ? this.is_plannable({...(settings.user ? {user: settings.user} : {user_id: user_id}), ...(settings.user_contract ? {user_contract: settings.user_contract} : {}), date: settings.date, data: data, remove_current: settings.remove_current, selfschedule: settings.selfschedule, check_self_schedules: settings.check_self_schedules, atw_only: settings.atw_only, atw_should_give_error: settings.atw_should_give_error }) : []); // Als je in een route zit hoef je voor de onderliggende blokken deze checks niet uit te voeren.

        if((_.size(messages.errors) == 0 && _.size(messages.warnings) == 0) || (!settings.show_messages && _.size(messages.errors) == 0))
        {
            if(settings.remove_current)
                this.unplan({date: settings.date, selfschedule: settings.selfschedule});

            let new_planning_model;

            if(settings.selfschedule)
            {
                new_planning_model = new SelfSchedulePlanningModel({controller: this.config.controller, data: {blueprint_block_id: this.get_bind_id(), user_id: user_id, date: settings.date, period: settings.period}})
                
                new_planning_model.commit_changes({reset_start_data: false, reset_changed_data: false, apply_data_to_state: settings.apply_data_to_state});
                new_planning_model.save();
            }
            else
            {
                if(!_.is_empty(data.relation_id))
                {
                    new_planning_model = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_field_data('id')}, date: {value: model => _.get_date_format(model.start_date_time, true) == settings.date, type: 'function'}, user_id: {value: -1}}, limit: 1}, models: {component_classes: {[Components.__PLANNING_COMPONENT__]: BlueprintBlockPlanningModel, [Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__]: RoutePlanningTaskModel}, limit: 1}});
    
                    // Dit mag eigenlijk nooit gebeuren, want is_plannable zou al een check moeten doen of je diegene nog wel kunt inplannen.
                    if(_.is_empty(new_planning_model))
                        return false;
    
                    new_planning_model.set_field_data({field: 'user_id', value: user_id});
                    
                    if(settings.route_planning_id && new_planning_model.config.component != Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__)
                    {
                        new_planning_model.set_component_name(Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__);
                        new_planning_model.set_field_data({field: 'component_id', value: Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__});
                        new_planning_model.set_field_data({field: 'structure_id', value: 10667});
                    }
                    else if(_.is_empty(settings.route_planning_id) && new_planning_model.config.component == Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__)
                    {
                        new_planning_model.set_component_name(Components.__PLANNING_COMPONENT__);
                        new_planning_model.set_field_data({field: 'component_id', value: Components.__PLANNING_COMPONENT__});
                        new_planning_model.set_field_data({field: 'structure_id', value: 10029});
                    }
                }
                else if(settings.route_planning_id)
                    new_planning_model = new RoutePlanningTaskModel({controller: this.config.controller, data: {blueprint_block_id: this.get_bind_id(), user_id: user_id, date: settings.date, component_id: Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__}});
                else
                    new_planning_model = new BlueprintBlockPlanningModel({controller: this.config.controller, data: {blueprint_block_id: this.get_bind_id(), user_id: user_id, date: settings.date, component_id: Components.__PLANNING_COMPONENT__}});

                // Als hij gekoppeld is aan een route, moeten we hem daar ook op zetten.
                new_planning_model.set_field_data({field: 'route_planning_id', value: (settings.route_planning_id ? settings.route_planning_id : null)});
                
                if(settings.creator_id)
                    new_planning_model.set_field_data({field: 'creator_id', value: settings.creator_id});
                
                if(settings.isAISuggestion)
                    new_planning_model.set_field_data({field: 'is_ai_suggestion', value: 't'});
    
                new_planning_model.commit_changes({reset_start_data: false, reset_changed_data: false, apply_data_to_state: settings.apply_data_to_state});
                
                // Als er een eenmalige uitzonderig op een vaste planning was voor deze medewerker op deze dienst kan hier weer weggehaald worden aangezien de medewerker weer opnieuw wordt ingepland op de dienst waar hij eerst eenmalig uitgepland was
                let recurring_user_exception_model = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_RECURRING_USER_EXCEPTION_COMPONENT__], filter_field: {user_id: {value: user_id}, blueprint_block_id: {value: this.get_bind_id()}, start_year_week: {value: new CustomDate(_.get_date_format(settings.date, true)).getYearWeek()}, removed: {value: 't', type: 'excludes'}}}, models: {limit: 1}});
    
                if(!_.is_empty(recurring_user_exception_model))
                {
                    recurring_user_exception_model.remove();
                    recurring_user_exception_model.commit_changes({reset_start_data: false, reset_changed_data: false});
                }
            }

            // We moeten ook naar de dag van gisteren kijken. Want de dienst die vandaag wordt ingepland kan invloed hebben op een roostervrije dag van gisteren. Dit omdat de rusttijd van gisteren wordt aangepast als je vandaag een dienst inplant.
            let yesterday = new CustomDate(settings.date);
            
            yesterday.setDate(yesterday.getDate() - 1);

            let planning_user_unavailability_schedule_free_models = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_USER_UNAVAILABILITY_SCHEDULE_FREE_COMPONENT__], filter_field: {user_id: {value: settings.user_id}, removed: {value: 't', type: 'excludes'}, date_check: {type: 'function', value: model => (_.get_date_format(model.start_date_time, true) == yesterday.getYearMonthDay() || _.get_date_format(model.start_date_time, true) == _.get_date_format(new_planning_model.get_field_data('start_date_time'), true) || _.get_date_format(model.start_date_time, true) == _.get_date_format(new_planning_model.get_field_data('end_date_time'), true))}}}, models: {component_classes: PlanningUserAvailabilityScheduleFreeModel}});

            if(!_.is_empty(planning_user_unavailability_schedule_free_models))
                for(let i in planning_user_unavailability_schedule_free_models)
                {
                    if(
                        // Als hij op dezelfde dag start moet hij altijd verwijderd worden.
                        settings.date == _.get_date_format(planning_user_unavailability_schedule_free_models[i].get_field_data('start_date_time'))
                        ||
                        // Als hij niet op dezelfde dag start moeten we kijken of de dag van de roostervrije registratie nogsteeds een vrije dag is.
                        !Planning.is_free_day({date: _.get_date_format(planning_user_unavailability_schedule_free_models[i].get_field_data('start_date_time'), true), controller: this.config.controller, user_id: user_id})
                    )
                    {
                        planning_user_unavailability_schedule_free_models[i].remove();
                        planning_user_unavailability_schedule_free_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
                    }
                }
            
            if(settings.success_callback)
                settings.success_callback();
            
            if(this.config.controller.component.state.selected_item && this.config.controller.component.state.selected_item.type != 'copy' && (this.config.controller.component.state.selected_item.component_id == Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__ || this.config.controller.component.state.selected_item.component_id == Components.__BLUEPRINT_BLOCK_COMPONENT__))
            {
                if(data.user_amount == 1)
                    this.config.controller.component.setState({selected_item: null});

                // Omdat hij anders het model nutteloos laat staan, waardoor het lijkt of er een change zit
                if(!this.has_changes())
                    this.remove({force: true});
            }
            
            let filter_field                = {};
            filter_field.blueprint_block_id = {value: this.get_field_data('id')};
            filter_field.date               = {type: 'function', value: model => (_.get_date_format((model instanceof Model ? model.get_field_data('start_date_time') : model.start_date_time), true) == settings.date)};
            filter_field.user_id            = {value: -1, type: 'excludes'};
            filter_field.removed            = {value: 't', type: 'excludes'};
            let planned_items               = this.config.controller.get_data_and_models({models: [Components.__PLANNING_COMPONENT__], filter_field: filter_field}); // Models ook toevoegen. Wanneer je in een loop plant kan de state nog niet zijn geupdate omdat er een vertraging in zit.

            if(data.user_amount == _.size(planned_items) && !settings.ignore_open_offer_check)
            {
                let open_planning_models = this.config.controller.get_models_from_data({data: {models: [Components.__OPEN_PLANNING_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_bind_id()}, date: {value: settings.date}}}});
                
                if(!_.is_empty(open_planning_models))
                {
                    for(let i in open_planning_models)
                        open_planning_models[i].remove();
                    
                    this.config.controller.save({url: Config.SERVER_REQUEST_URL + '?ajax_id=37&component=' + Components.__OPEN_PLANNING_COMPONENT__ + '&form-action=edit', models: {[Components.__OPEN_PLANNING_COMPONENT__]: open_planning_models}}).then(resp => this.check_open_offers(settings));
                }
                else
                    this.check_open_offers(settings);
            }
            else
            {
                let related_models = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_OFFER_COMPONENT__, Components.__OPEN_PLANNING_COMPONENT__], models_object: 'array', filter_field: {blueprint_block_id: {value: this.get_bind_id()}, user_id: {value: user_id}, date: { value: settings.date }, state: {value: ['Afgewezen'], type: 'excludes'}, removed: {value: 't', type: 'excludes'}}}, models: {return_models_split_components: false, keep_keys: false}});

                for(let i in related_models)
                {
                    related_models[i].remove();
                    related_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
                }
            }

            return true;
        }
        else if(_.size(messages.errors) > 0 && settings.show_messages)
        {
            this.config.controller.component.setState({messageTitle: 'Let op', messageContent: messages.errors});
            
            if(!this.has_changes())
                this.remove({force: true}); // Omdat hij het anders als een change blijft zien.
        }
        else if(_.size(messages.warnings) > 0 && settings.show_messages)
        {
            messages.warnings.push('');
            messages.warnings.push('Weet je zeker dat je deze medewerker evengoed wilt inplannen?');
            this.config.controller.component.setState({messageTitle: 'Let op', messageContent: messages.warnings, messageConfirmCallback: this.plan.bind(this), ...(settings.success_callback ? {messageCloseCallback: settings.success_callback} : {}), messageConfirmCallbackParams: {...settings, ...{show_messages: false}}});
        }

        return false;
    }
    
    check_open_offers(settings) {
        let planning_offers = this.config.controller.get_data({models: [Components.__PLANNING_OFFER_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_bind_id()}, date: {value: settings.date}, state: {value: ['Aangeboden', 'Ingeschreven'], type: 'includes_desc'}}});

        if(!_.is_empty(planning_offers))
            this.config.controller.component.setState({messageTitle: 'Deze dienst is nog aangeboden', messageContent: ['', 'Wil je de openstaande aanbiedingen van de zojuist ingeplande diensten intrekken? Als je dit niet doet blijven ze open staan en kunnen mensen er nog op reageren.'], messageConfirmCallback: this.remove_open_offers.bind(this), messageCloseCallback: () => {}, messageConfirmCallbackParams: settings});
    }
    
    remove_open_offers(settings) {
        let current_planned_users   = this.config.controller.get_data({ models: [Components.__PLANNING_COMPONENT__], filter_field: { blueprint_block_id: { value: this.get_field_data('id') }, user_id: { value: -1, type: 'excludes' }, date: { value: model => _.get_date_format(model.start_date_time, true) == settings.date }, removed: {value: 't', type: 'excludes'} }, format: 'asGrouped', key: 'user_id' });
        let planning_offer_models   = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_OFFER_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_bind_id()}, date: {value: settings.date}, state: {value: ['Aangeboden', 'Ingeschreven'], type: 'includes_desc'}}}});

        for(let i in planning_offer_models)
        {
            // current_planned_users check, want als iemand ingepland is hoeven we de aangeboden dienst niet op ingetrokken te zetten, want diegene is ingepland. Dan kunnen we de aangeboden dienst dus gewoon verwijderen.
            if(planning_offer_models[i].get_field_data('state') == 'Ingeschreven' && !current_planned_users[planning_offer_models[i].get_field_data('user_id')])
            {
                planning_offer_models[i].set_field_data({field: 'state', value: 'Ingetrokken'});
                planning_offer_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
            }
            else
                planning_offer_models[i].remove();
        }
        
        this.config.controller.save({url: Config.SERVER_REQUEST_URL + '?ajax_id=37&component=' + Components.__PLANNING_OFFER_COMPONENT__ + '&form-action=edit', models: {[Components.__PLANNING_OFFER_COMPONENT__]: planning_offer_models}});
    }
    
    cancel(settings) {
        // Dienst eerst volledig uitplannen
        this.unplan(settings);
        
        // Geannuleerde registratie aanmaken
        let model = new BlueprintBlockPlanningModel({controller: this.config.controller, data: {blueprint_block_id: this.get_bind_id(), user_id: -1, state: 'Geannuleerd', date: settings.date, component_id: Components.__PLANNING_COMPONENT__}});

        model.commit_changes({reset_start_data: false, reset_changed_data: false});
        
        // Aangeboden diensten die nog open staan kunnen ook verwijderd worden.
        let offers = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_OFFER_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_field_data('id')}, removed: {value: 't', type: 'excludes'}, state: {value: 'Aangeboden'}}}});
        
        if(!_.is_empty(offers))
            for(let i in offers)
            {
                offers[i].remove();
                offers[i].commit_changes({reset_start_data: false, reset_changed_data: false});
            }
    }
    
    reopen(settings) {
        settings = {...{}, ...settings};
        
        let planning_models = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_bind_id()}, date: {type: 'function', value: model => settings.date == _.get_date_format(model.start_date_time, true)}}}, models: {component_classes: BlueprintBlockPlanningModel}});

        for(let i in planning_models)
        {
            planning_models[i].remove();
            planning_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
        }
        
        //Mocht je hem perongeluk hebben geannuleerd en je heropent hem weer voordat je gepubliceerd hebt moeten we de offers die we verwijderd hadden in de cancel functie weer undo-en
        let offers = this.config.controller.get_models({models: [Components.__PLANNING_OFFER_COMPONENT__, Components.__OPEN_PLANNING_COMPONENT__], models_object: 'array', return_models_split_components: false, keep_keys: false, filter_field: {blueprint_block_id: {value: this.get_field_data('id')}, state: {value: 'Aangeboden'}}});
        
        if(!_.is_empty(offers))
            for(let i in offers)
                offers[i].undo_changes();
    }
    
    unplan(settings) {
        settings = {...{planning_id: null, user_id: null, cancel: false, selfschedule: false}, ...settings};

        let planning_models;
        let components = (settings.selfschedule ? [Components.__SELF_SCHEDULE_PLANNING_COMPONENT__] : [Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__] );

        if(!_.is_empty(settings.planning_id))
            planning_models = this.config.controller.get_models_from_data({data: {models: components, filter_field: {id: {value: settings.planning_id}}}, models: {return_models_split_components: false, keep_keys: false, component_classes: {[Components.__PLANNING_COMPONENT__]: BlueprintBlockPlanningModel, [Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__]: RoutePlanningTaskModel, [Components.__SELF_SCHEDULE_PLANNING_COMPONENT__]: SelfSchedulePlanningModel}}});
        else if(!_.is_empty(settings.user_id))
            planning_models = this.config.controller.get_models_from_data({data: {models: components, filter_field: {blueprint_block_id: {value: this.get_bind_id()}, date: {type: 'function', value: model => settings.date == _.get_date_format(model.start_date_time, true)}, user_id: {value: settings.user_id}}}, models: {return_models_split_components: false, keep_keys: false, component_classes: {[Components.__PLANNING_COMPONENT__]: BlueprintBlockPlanningModel, [Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__]: RoutePlanningTaskModel, [Components.__SELF_SCHEDULE_PLANNING_COMPONENT__]: SelfSchedulePlanningModel}}});
        else
            planning_models = this.config.controller.get_models_from_data({data: {models: components, filter_field: {blueprint_block_id: {value: this.get_bind_id()}, date: {type: 'function', value: model => settings.date == _.get_date_format(model.start_date_time, true)}}}, models: {return_models_split_components: false, keep_keys: false, component_classes: {[Components.__PLANNING_COMPONENT__]: BlueprintBlockPlanningModel, [Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__]: RoutePlanningTaskModel, [Components.__SELF_SCHEDULE_PLANNING_COMPONENT__]: SelfSchedulePlanningModel}}});

        if(_.size(planning_models) == 0)
            return false;

        for(let i in planning_models)
            planning_models[i].unplan(settings);
    }
    
    remove_with_check(settings) {
        let success = () => {
            this.remove(settings);
            this.commit_changes({reset_start_data: false, reset_changed_data: false});
        }

        // Als het niet een eenmalige dienst is moeten we gewoon de super class aanroepen
        if(this.get_field_data('structure_id') != 10070)
            return success();

        let current_planning = this.config.controller.get_data({models: [Components.__PLANNING_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_bind_id()}, removed: {value: 't', type: 'excludes'}, user_id: {value: -1, type: 'excludes'}}});
        
        if(_.size(current_planning) == 0)
            return success();

        this.config.controller.component.setState({messageTitle: 'Let op', messageContent: ['Deze dienst staat nog ingepland op een medewerker. Als je hem verwijdert wordt de medewerker ook uitgepland.', '', 'Weet je zeker dat je dit wilt doen?'], messageConfirmCallback: success.bind(this)});
    }
    
    remove(settings) {
        settings = {...{}, ...settings};

        // Anders krijgen we een error omdat het item niet meer bestaat.
        if(this.config.controller.component.state.selected_item && this.config.controller.component.state.selected_item.component_id == Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__ && this.config.controller.component.state.selected_item.id == this.get_field_data('id'))
            this.config.controller.component.setState({selected_item: null});

        // Geen force change, want als we alleen de dienst willen verwijderen moet niet ook al de rest verwijderd worden.
        if(this.get_field_data('structure_id') == 10070 && !settings.force)
        {
            let removed_planning_items  = null;
            const success               = (saveConcept) => {
                const related_models    = this.config.controller.get_models_from_data({merge_data_and_models: false, data: {models: [Components.__PLANNING_OFFER_COMPONENT__, Components.__OPEN_PLANNING_COMPONENT__, Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__, Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__, Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__, Components.__BLUEPRINT_BLOCK_SETTING_EXCEPTION_COMPONENT__, Components.__SHIFT_NOTE_COMPONENT__], models_object: 'array', filter_field: {blueprint_block_id: {value: this.get_bind_id()}, removed: {value: 't', type: 'excludes'}}}, models: {return_models_split_components: false, keep_keys: false, component_classes: {[Components.__PLANNING_COMPONENT__]: BlueprintBlockPlanningModel, [Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__]: RoutePlanningTaskModel}}});

                for(const i in related_models)
                {
                    related_models[i].remove();
                    related_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
                }

                super.remove(settings);
                
                if(saveConcept)
                    this.config.controller.component._saveConcept();
            }

            if(!this.has_data())
                removed_planning_items = this.config.controller.get_models({models: [Components.__PLANNING_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_bind_id()}, removed: {value: 't'}}});

            // Als je een dienst wijzigt en een deel van de planning blijft behouden. Krijg je een situatie dat een planning is gekoppeld aan een new- dienst. Wanneer je dan de dienst verwijderd wordt die uit de state gehaald en het model verwijderd. Maar de planning heeft al een id en blijft daarom bestaan. Dit kan fouten veroorzaken. Want de planning heeft dan geen referentie meer naar de blueprint block
            if(!_.is_empty(removed_planning_items))
            {
                let models_to_save          = {};
                let blueprint_block_setting = this.config.controller.get_data({models: [Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_bind_id()}}, limit: 1});

                _.set_object_chain(models_to_save, {chain: [this.config.name, this.get_bind_id(), this.get_field_data('start_date')], value: [{id: this.get_bind_id(), component_id: this.config.name}, {id: blueprint_block_setting.id, component_id: Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__}]});

                this.config.controller.component._publish(null, {models: models_to_save, save_settings: { remove_models_after_save: false}, before_apply_models_to_state_callback: (response, settings) => {
                        if(response.status)
                        {
                            // Anders wordt het item weer opnieuw in de state gezet, terwijl het model verwijderd wordt.
                            for(const componentId in response.models)
                            {
                                if(componentId != this.config.name)
                                    continue;

                                for(const id in response.models[componentId])
                                    response.models[componentId][id] = {id: response.models[componentId].id, removed: 't'};
                            }
                        }
                }}).then(response => {
                    if(response.status)
                    {
                        for(const i in removed_planning_items)
                        {
                            removed_planning_items[i].set_field_data({field: 'blueprint_block_id', value: this.get_bind_id()});
                            removed_planning_items[i].commit_changes({reset_start_data: false, reset_changed_data: false});
                        }
                        
                        let blueprint_block_setting_model = this.config.controller.get_models({models: [Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__], filter_field: {blueprint_block_id: {value: this.get_bind_id()}}, limit: 1});

                        if(blueprint_block_setting_model)
                        {
                            blueprint_block_setting_model.set_field_data({field: 'blueprint_block_id', force_change: true, value: this.get_bind_id()}); //force_change omdat dit record vanuit de publish al het nieuwe id krijgt, die dan niet meer in de changed_data meekomt wanneer je het concept opslaat
                            blueprint_block_setting_model.commit_changes({reset_start_data: false, reset_changed_data: false});
                        }

                        success(true);
                    }
                });
            }
            else
                success();
        }
        else
            return super.remove(settings);
    }
    
    after_field_change_callback(settings) {
        super.after_field_change_callback(settings);
        
        if(settings.field == 'customer_object_id')
        {
            let customer_object = this.config.controller.get_data({models: [Components.__CUSTOMER_OBJECT_COMPONENT__], filter_field: {id: {value: settings.value}}, limit: 1});

            this.set_field_data({field: 'customer_id', value: customer_object.customer_id, trigger_after_field_change: false});
        }
    }
}

class SettingModel extends Model {
    constructor(config) {
        super(config);

        this.relations              = [];
        this.in_blueprint           = false;
        this._format_blueprint_data = this._format_blueprint_data.bind(this);
    }

    set_field_data(settings) {
        if(settings.field == 'pause_start' || settings.field == 'pause_stop')
        {
            let pauses = _.cloneDeep(this.get_field_data('pauses'));
            
            if(pauses == null)
                pauses = {0: {}};

            pauses[0][(settings.field == 'pause_start' ? 'start_time' : 'end_time')]    = settings.value;
            settings.field                                                              = 'pauses';
            settings.value                                                              = pauses;
        }
        else if(settings.field == 'end_time')
        {
            settings.field = 'duration';
            
            if(!_.is_empty(settings.value))
            {
                if(settings.value > this.get_field_data('start_time'))
                    settings.value = _.minutes_to_time(_.time_to_minutes(settings.value) - _.time_to_minutes(this.get_field_data('start_time'))) + ':00';
                else
                    settings.value = _.minutes_to_time((_.time_to_minutes(settings.value) + (24*60) ) - _.time_to_minutes(this.get_field_data('start_time'))) + ':00';
            }
        }
        else if(['deviating_invoice_start_time', 'deviating_invoice_duration', 'deviating_invoice_end_time', 'deviating_invoice_pause_start', 'deviating_invoice_pause_stop'].includes(settings.field)) {
            const deviating_time    = _.cloneDeep(this.get_field_data('deviating_invoice_time'));
            const field             = settings.field.substring('deviating_invoice_'.length);
            
            if(!_.is_empty(settings.value))
            {
                if(field == 'end_time')
                {
                    if(settings.value > this.get_field_data('deviating_invoice_start_time'))
                        deviating_time.duration = _.minutes_to_time(_.time_to_minutes(settings.value) - _.time_to_minutes(this.get_field_data('deviating_invoice_start_time'))) + ':00';
                    else
                        deviating_time.duration = _.minutes_to_time((_.time_to_minutes(settings.value) + (24*60) ) - _.time_to_minutes(this.get_field_data('deviating_invoice_start_time'))) + ':00';
                }
                else
                    deviating_time[field] = settings.value;
            }
            else if(deviating_time[field])
                delete deviating_time[field];

            return super.set_field_data({ field: 'deviating_invoice_time', value: deviating_time });
        }
        else if(settings.field == 'user_amount' && !_.is_empty(settings.value) && settings.value != '$_EMPTY_PLACEHOLDER_$')
        {
            // Deze check zit niet in check_values omdat het systeem de user_amount wel op 0 mag zetten. Alleen de gebruiker mag dit niet doen vanuit een form.
            const value = parseInt(settings.value);
            
            if(isNaN(value) || value < 1)
                settings.value = this.get_field_data('user_amount');
        }

        super.set_field_data(settings)
    }
    
    add_notification(value) {
        let notifications = _.cloneDeep(this.get_field_data('notifications'));

        if(notifications == null)
            notifications = [];
        else
            notifications = _.values(notifications);
        
        notifications.push(value);
        
        this.set_field_data({field: 'notifications', value: notifications});
    }
    
    remove_notification(index) {
        let notifications = _.cloneDeep(this.get_field_data('notifications'));

        if(notifications == null)
            return;

        if(_.size(notifications) == 1)
            notifications = null;
        else
            notifications.splice(index, 1);
        
        this.set_field_data({field: 'notifications', value: notifications});
    }
    
    add_reminder(value) {
        let reminders = _.cloneDeep(this.get_field_data('reminders'));

        if(reminders == null)
            reminders = [];
        
        reminders.push(value);
        
        this.set_field_data({field: 'reminders', value: reminders});
    }
    
    remove_reminder(index) {
        let reminders = _.cloneDeep(this.get_field_data('reminders'));

        if(reminders == null)
            return;
        
        if(_.size(reminders) == 1)
            reminders = null;
        else
            reminders = _.omit(reminders, index);
        
        this.set_field_data({field: 'reminders', value: reminders});
    }
    
    toggle_disabled_compensation(key) {
        let disabled_compensations = _.cloneDeep(this.get_field_data('disabled_compensations'));

        if(disabled_compensations == null)
            disabled_compensations = {};

        if(!disabled_compensations[key] || disabled_compensations[key] == 'f')
            disabled_compensations[key] = 't';
        else
            disabled_compensations[key] = 'f';

        this.set_field_data({field: 'disabled_compensations', value: disabled_compensations});
    }
    
    toggle_deviating_invoice_time() {
        let deviating_invoice_time = _.cloneDeep(this.get_field_data('deviating_invoice_time'));

        if(deviating_invoice_time == null)
            deviating_invoice_time = {};

        if(!deviating_invoice_time.active || deviating_invoice_time.active == 'f')
            deviating_invoice_time.active = 't';
        else
            deviating_invoice_time = {active: 'f'};

        this.set_field_data({field: 'deviating_invoice_time', value: deviating_invoice_time});
    }
    
    get_field_data(field, default_value = null) {
        if(field == 'pause_start' || field == 'pause_stop')
        {
            let pauses = super.get_field_data('pauses');
            
            if(pauses == null)
                return default_value;
            
            return pauses[0][(field == 'pause_start' ? 'start_time' : 'end_time')] || default_value;
        }
        
        if(field == 'end_time')
        {
            if(_.is_empty(super.get_field_data('start_time')) || _.is_empty(super.get_field_data('duration')))
                return default_value;

            return _.add_minutes_to_time(super.get_field_data('start_time'), _.time_to_minutes(super.get_field_data('duration')));
        }
        
        if(field.substring(0, 22) == 'disabled_compensation_')
        {
            let disabled_compensations  = super.get_field_data('disabled_compensations');
            let key                     = field.substring(22);

            if(disabled_compensations == null || !disabled_compensations[key])
                return false;
            
            return (disabled_compensations[key] == 't');
        }
        
        if(['deviating_invoice_start_time', 'deviating_invoice_duration', 'deviating_invoice_end_time', 'deviating_invoice_pause_start', 'deviating_invoice_pause_stop'].includes(field)) {
            const deviating_time = this.get_field_data('deviating_invoice_time');
            
            if(field == 'deviating_invoice_start_time')
                return deviating_time.start_time || default_value;
            else if(field == 'deviating_invoice_duration')
                return deviating_time.duration || default_value;
            else if(field == 'deviating_invoice_pause_start')
                return deviating_time.pause_start || default_value;
            else if(field == 'deviating_invoice_pause_stop')
                return deviating_time.pause_stop || default_value;
            else
            {
                if(_.is_empty(this.get_field_data('deviating_invoice_start_time', default_value)) || _.is_empty(this.get_field_data('deviating_invoice_duration', default_value)))
                    return default_value;

                return _.add_minutes_to_time(this.get_field_data('deviating_invoice_start_time', default_value), _.time_to_minutes(this.get_field_data('deviating_invoice_duration', default_value)));
            }
        }
        
        return super.get_field_data(field, default_value);
    }

    commit_changes(settings)
    {
        settings = {...{apply_data_to_state: true}, ...settings};

        super.commit_changes(settings);

        // Gerelateerde gegevens aanpassen, dit doen we natuurlijk alleen als het record niet verwijderd is. Want dan heeft het geen nut om dingen door te voeren want het item is gewoon net verwijderd. Voor uitzonderingen doen we dit wel, want het kan natuurlijk zijn dat de uitzondering ervoor heeft gezorgd dat de tijd aangepast is.
        if(settings.apply_data_to_state && (this.get_field_data('removed') != 't' || this instanceof RouteSettingExceptionModel || this instanceof BlueprintBlockSettingExceptionModel))
            this.set_relation_data();
    }
    
    set_relation_data() {
        if(!_.is_empty(this.relations))
            for(let i in this.relations)
            {
                let planning_models = this.config.controller.get_models_from_data({data: {models: [this.relations[i].component], filter_field: {[this.relations[i].relation_field]: {value: this.get_field_data(this.relations[i].relation_field)}, removed: {value: 't', type: 'excludes'}, date: {type: 'function', value: model => new CustomDate(_.get_date_format(model.start_date_time, true)).getYearWeek() == new CustomDate(_.get_date_format(this.get_field_data('start_date'), true)).getYearWeek()}}}, models: {return_models: true, component_classes: this.relations[i].model}});

                if(!_.is_empty(planning_models))
                {
                    let data = {};
                
                    // Voor de gelinkte velden gaan we kijken wat de wijzigingen zijn.
                    for(let x in this.relations[i].fields)
                    {
                        let field = this.relations[i].fields[x];

                        // Start tijd en duur wordt omgezet naar start_date_time en end_date_time, want dat zijn de velden zoals ze in de planning gebruikt worden.
                        if(field == 'start_time' || field == 'duration')
                        {
                            let date = new CustomDate(this.get_field_data('start_date')).getMonday();
                            
                            // De start_date van de settings valt altijd op maandag.
                            date.setDate(date.getDate() + parseInt(this.get_field_data('day')));
    
                            date                = date.getYearMonthDay();
                            let end_date_time   = CustomDate.getCustomDateTime(date + ' ' + _.get_time_format(this.get_field_data('start_time')) + ':00');
            
                            end_date_time.setMinutes(end_date_time.getMinutes() + _.time_to_minutes(this.get_field_data('duration')));
            
                            data['start_date_time'] = date + ' ' + _.get_time_format(this.get_field_data('start_time')) + ':00';
                            data['end_date_time']   = end_date_time.getDateTime(true);
                        }
                        else
                            data[field] = this.get_field_data(field);
                    }

                    // Data doorvoeren op de planning
                    if(!_.is_empty(data))
                        for(let x in planning_models)
                        {
                            for(let field in data)
                                planning_models[x].set_field_data({field: field, value: data[field], trigger_after_field_change_update: false});

                            planning_models[x].commit_changes({reset_start_data: false, reset_changed_data: false});
                            
                            if(!planning_models[x].has_changes())
                                planning_models[x].remove({force: true});
                        }
                }
            }
    }
    
    compare_changes(settings) {
        let specialFields   = ['reminders', 'notifications', 'checkpoint_routes', 'disabled_compensations', 'travel_expense_route', 'deviating_invoice_time'];
        let exclude_fields  = ['id', 'structure_id', 'fielddefine_id', 'start_date', 'blueprint_block_id', 'route_id'];
        settings            = { emptyText: 'Geen', ...settings };
        let changed_data    = settings.changed_data || this.get_changed_data();
        let start_data      = _.cloneDeep(settings.start_data || this.start_data);
        let sorted_fields   = _.sortBy(_.keys(changed_data), field => specialFields.includes(field));
        let users           = this.config.controller.get_data({models: [Components.__EMPLOYEE_COMPONENT__], format: 'asGrouped', key: 'id'});
        let properties      = {};
        let new_keys        = {};
        let old_keys        = {};

        for(let i in sorted_fields)
        {
            let field = sorted_fields[i];
            
            if(exclude_fields.includes(field) || !this.fielddefines[field])
                continue;

            properties[field] = { label: this.fielddefines[field].label, value: _.cloneDeep(settings.model ? settings.model.get_field_data(field) : changed_data[field] || this.get_field_data(field)), old_value: start_data[field] };
            
            if(properties[field].old_value == '$_EMPTY_PLACEHOLDER_$' || properties[field].old_value == -31121985)
                properties[field].old_value = null;

            switch(field)
            {
                case 'pauses':
                    if(!_.is_empty(properties[field].value) && !_.is_empty(properties[field].value[0].start_time))
                        properties[field].value = _.get_time_format(properties[field].value[0].start_time) + ' t/m ' + _.get_time_format(properties[field].value[0].end_time);
                    else
                        properties[field].value = settings.emptyText;
                    
                    if(!_.is_empty(properties[field].old_value) && !_.is_empty(properties[field].old_value[0].start_time))
                        properties[field].old_value = _.get_time_format(properties[field].old_value[0].start_time) + ' t/m ' + _.get_time_format(properties[field].old_value[0].end_time);
                    else
                        properties[field].old_value = settings.emptyText;
                    
                    break;
                case 'reminders':
                    properties[field].label         = 'Herinnering(en)';
                    properties[field].records       = [];
                    properties[field].old_records   = [];
                    new_keys                        = {};
                    old_keys                        = {};
                    
                    for(let j in properties[field].old_value)
                        old_keys[_.values(properties[field].old_value[j]).join('-')] = true;
                    
                    for(let j in properties[field].value)
                    {
                        let key         = _.values(properties[field].value[j]).join('-');
                        new_keys[key]   = true;
                        
                        if(old_keys[key])
                            continue;

                        properties[field].records.push({value: properties[field].value[j].minutes + ' minuten ' + ReminderTypes[properties[field].value[j].type].toLowerCase() + ' aan ' + (properties[field].value[j].receiver == 'planned_user' ? 'ingeplande medewerker' : (users[properties[field].value[j].receiver] ? users[properties[field].value[j].receiver].display_name : 'onbekend'))});
                    }
                    
                    for(let j in properties[field].old_value)
                    {
                        if(new_keys[_.values(properties[field].old_value[j]).join('-')])
                            continue;

                        properties[field].old_records.push({value: properties[field].old_value[j].minutes + ' minuten ' + ReminderTypes[properties[field].old_value[j].type].toLowerCase() + ' aan ' + (properties[field].old_value[j].receiver == 'planned_user' ? 'ingeplande medewerker' : (users[properties[field].old_value[j].receiver] ? users[properties[field].old_value[j].receiver].display_name : 'onbekend'))});
                    }

                    break;
                case 'notifications':
                    properties[field].label         = 'Melding(en)';
                    properties[field].records       = [];
                    properties[field].old_records   = [];
                    new_keys                        = {};
                    old_keys                        = {};
                    
                    for(let j in properties[field].old_value)
                        old_keys[_.values(properties[field].old_value[j]).join('-')] = true;
                    
                    for(let j in properties[field].value)
                    {
                        let key         = _.values(properties[field].value[j]).join('-');
                        new_keys[key]   = true;
                        
                        if(old_keys[key])
                            continue;
                        
                        properties[field].records.push({value: NotificationTypes[properties[field].value[j].type] + ' aan ' + (properties[field].value[j].receiver == 'planned_user' ? 'ingeplande medewerker' : (users[properties[field].value[j].receiver] ? users[properties[field].value[j].receiver].display_name : 'onbekend'))});
                    }

                    for(let j in properties[field].old_value)
                    {
                        if(new_keys[_.values(properties[field].old_value[j]).join('-')])
                            continue;
                        
                        properties[field].old_records.push({value: NotificationTypes[properties[field].old_value[j].type] + ' aan ' + (properties[field].old_value[j].receiver == 'planned_user' ? 'ingeplande medewerker' : (users[properties[field].old_value[j].receiver] ? users[properties[field].old_value[j].receiver].display_name : 'onbekend'))});
                    }

                    break;
                case 'checkpoint_routes':
                    properties[field].label         = 'Scanpunt route(s)';
                    properties[field].records       = [];
                    properties[field].old_records   = [];
                    let checkpoint_routes           = this.config.controller.get_data({models: [Components.__CUSTOMER_OBJECT_CHECKPOINT_ROUTE_COMPONENT__], format: 'asGrouped', key: 'id'});
                    new_keys                        = {};
                    old_keys                        = {};
                    
                    for(let j in properties[field].old_value)
                        old_keys[_.values(properties[field].old_value[j]).join('-')] = true;
                    
                    for(let j in properties[field].value)
                    {
                        let key         = _.values(properties[field].value[j]).join('-');
                        new_keys[key]   = true;
                        
                        if(old_keys[key])
                            continue;

                        properties[field].records.push({value: 'Route ' + checkpoint_routes[properties[field].value[j].checkpoint_route_id].title + ' om ' + _.get_time_format(properties[field].value[j].start_time)});
                    }

                    for(let j in properties[field].old_value)
                    {
                        if(new_keys[_.values(properties[field].old_value[j]).join('-')])
                            continue;
                            
                        properties[field].old_records.push({value: 'Route ' + checkpoint_routes[properties[field].old_value[j].checkpoint_route_id].title + ' om ' + _.get_time_format(properties[field].old_value[j].start_time)});
                    }
                    
                    break;
                case 'travel_expense_route':
                    properties[field].label         = 'Reiskostenvergoeding route';
                    properties[field].records       = [];
                    properties[field].old_records   = [];

                    for(let j in properties[field].value)
                    {
                        if(!properties[field].old_value || !properties[field].old_value[j] || properties[field].value[j] != properties[field].old_value[j])
                            properties[field].records.push({value: properties[field].value[j].title + ' (Kilometers ' + (properties[field].value[j].compensate_distance == 'f' ? 'NIET ' : '') + 'uitbetalen)'});
                    }

                    for(let j in properties[field].old_value)
                    {
                        if(!properties[field].value || !properties[field].value[j] || properties[field].value[j] != properties[field].old_value[j])
                            properties[field].old_records.push({value: properties[field].old_value[j].title + ' (Kilometers ' + (properties[field].old_value[j].compensate_distance == 'f' ? 'NIET ' : '') + 'uitbetalen)'});
                    }
                    
                    break;
                case 'disabled_compensations':
                    properties[field].label    = 'Niet toegepaste vergoedingen';
                    properties[field].records  = [];
                    
                    for(let compensation in properties[field].value)
                        if(properties[field].value[compensation] == 't')
                            properties[field].records.push({value: DisabledCompensationLabels[compensation]});
                    
                    break;
                case 'deviating_invoice_time':
                    const startTime     = this.get_field_data('start_time') || (settings.model ? settings.model.get_field_data('start_time') : null);
                    const duration      = this.get_field_data('duration') || (settings.model ? settings.model.get_field_data('duration') : null);
                    const pauseStart    = (settings.model ? settings.model.get_field_data('deviating_invoice_time_pause_start') : null) || this.get_field_data('pause_start') || (settings.model ? settings.model.get_field_data('pause_start') : null);
                    const pauseStop     = (settings.model ? settings.model.get_field_data('deviating_invoice_time_pause_stop') : null) || this.get_field_data('pause_stop') || (settings.model ? settings.model.get_field_data('pause_stop') : null);
                    const oldValue      = _.cloneDeep(properties[field]);

                    if(!_.is_empty(oldValue.value) && oldValue.value.active != 'f' && !_.is_empty(oldValue.value.start_time))
                    {
                        properties[field].value = _.get_time_format(oldValue.value.start_time || startTime) + ' t/m ' + _.add_minutes_to_time(oldValue.value.start_time || startTime, _.time_to_minutes(oldValue.value.duration || duration));

                        if((!_.is_empty(oldValue.value.pause_start) || !_.is_empty(pauseStart)) && (!_.is_empty(oldValue.value.pause_stop) || !_.is_empty(pauseStop)))
                            properties[field].value += ' -> pauze: ' + _.get_time_format(oldValue.value.pause_start || pauseStart) + ' t/m ' + _.get_time_format(oldValue.value.pause_stop || pauseStop);
                    }
                    else
                        oldValue.value = settings.emptyText;
                    
                    if(!_.is_empty(oldValue.old_value) && oldValue.old_value.active != 'f' && !_.is_empty(oldValue.old_value.start_time))
                    {
                        properties[field].old_value = _.get_time_format(oldValue.old_value.start_time || startTime) + ' t/m ' + _.add_minutes_to_time(oldValue.old_value.start_time || startTime, _.time_to_minutes(oldValue.old_value.duration || duration));
                        
                        if((!_.is_empty(oldValue.old_value.pause_start) || !_.is_empty(pauseStart)) && (!_.is_empty(properties[field].old_value.pause_stop) || !_.is_empty(pauseStop)))
                            properties[field].old_value += ' -> pauze: ' + _.get_time_format(properties[field].old_value.pause_start || pauseStart) + ' t/m ' + _.get_time_format(properties[field].old_value.pause_stop || pauseStop);
                    }
                    else
                        properties[field].old_value = settings.emptyText;
                    
                break;
            }
            
            if(typeof properties[field].value == 'object')
                properties[field].value = '';
            
            switch(_.format_input(this.fielddefines[field].fieldtype_id))
            {
                // date
                case 4:
                    if(!_.is_empty(properties[field].value))
                        properties[field].value = _.get_date_format(properties[field].value);
                    
                    if(!_.is_empty(properties[field].old_value))
                        properties[field].old_value = _.get_date_format(properties[field].old_value);
                // tekstveld
                case 8:
                    if(_.is_empty(properties[field].value))
                        properties[field].value = settings.emptyText;
                    
                    if(_.is_empty(properties[field].old_value))
                        properties[field].old_value = settings.emptyText;
                    
                    break;
                
                // select
                case 14:
                    if(!_.is_empty(properties[field].value))
                    {
                        let options             = settings.custom_fielddefine_options && settings.custom_fielddefine_options[field] ? settings.custom_fielddefine_options[field] : this.fielddefines[field].options;
                        if(!_.is_empty(options))
                            properties[field].value = _.map(_.sortBy(properties[field].value.toString().split(',')), value => _.filter(options, option => option.value == value)[0].label).join(', ');
                        else
                            properties[field].value = settings.emptyText;
                    }
                    else
                        properties[field].value = settings.emptyText;
                    
                    if(!_.is_empty(properties[field].old_value))
                    {
                        let options                 = settings.custom_fielddefine_options && settings.custom_fielddefine_options[field] ? settings.custom_fielddefine_options[field] : this.fielddefines[field].options;
                        properties[field].old_value = _.map(
                            _.sortBy(properties[field].old_value.toString().split(',')), value => {
                                const foundOption = _.find(options, option => option.value == value.trim());
                                
                                return foundOption ? foundOption.label : value;
                            }
                        ).join(', ');
                    }
                    else
                        properties[field].old_value = settings.emptyText;
                    
                    break;
                
                // tijd zowel 24 uur notatie als tijd als notatie
                case 24:
                case 31:
                    if(!_.is_empty(properties[field].value))
                        properties[field].value = _.get_time_format(properties[field].value);

                    if(!_.is_empty(properties[field].old_value))
                        properties[field].old_value = _.get_time_format(properties[field].old_value);
                break;
            }
        }
        
        return properties;
    }
    
    _format_blueprint_data(models, settings) {
        let formatted_data                      = [];
        let year_week                           = (this.in_blueprint && this.get_field_data('start_date') < moment().format('YYYY-MM-DD') ? moment() : moment(this.get_field_data('start_date'))).format('GGGGWW');
        let customer_objects                    = this.config.controller.get_data({models: [Components.__CUSTOMER_OBJECT_COMPONENT__], format: 'asGrouped', key: 'id'});
        let customer_object_projects            = this.config.controller.get_data({models: [Components.__CUSTOMER_OBJECT_PROJECT_COMPONENT__], format: 'asGrouped', key: 'id'});
        let blueprint_block_settings            = this.config.controller.get_data({models: [Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__], format: 'asGrouped', key: {'blueprint_block_id': '$auto_increment$'}, sort: [{field: 'start_date', by: 'desc'}]});
	    let blueprint_block_setting_exceptions  = this.config.controller.get_data({models: [Components.__BLUEPRINT_BLOCK_SETTING_EXCEPTION_COMPONENT__], filter_field: {removed: {value: 't', type: 'excludes'}}, format: 'asGrouped', key: {'blueprint_block_id': 'start_date'}, sort: [{field: 'start_date', by: 'desc'}]});
	    let route_settings                      = this.config.controller.get_data({models: [Components.__PLANNING_ROUTE_SETTING_COMPONENT__], filter_field: {removed: {value: 't', type: 'excludes'}}, format: 'asGrouped', key: {'route_id': '$auto_increment$'}, sort: [{field: 'start_date', by: 'desc'}]});
	    let route_setting_exceptions            = this.config.controller.get_data({models: [Components.__PLANNING_ROUTE_SETTING_EXCEPTION_COMPONENT__], filter_field: {removed: {value: 't', type: 'excludes'}}, format: 'asGrouped', key: {'route_id': 'start_date'}, sort: [{field: 'start_date', by: 'desc'}]});
        let route_parents                       = this.config.controller.get_data({models: [Components.__ROUTE_PARENT_COMPONENT__], format: 'asGrouped', key: 'id'});
        
        for(let i in models)
        {
            let item;

            if(models[i].component_id == Components.__PLANNING_ROUTE_COMPONENT__)
                item = Planning.get_route_data_for_date({route: models[i], settings: route_settings[models[i].id], year_week: year_week, exceptions: route_setting_exceptions[models[i].id], route_parents });
            else
            {
                item = Planning.get_blueprint_block_data_for_date({ blueprint_block: models[i], settings: blueprint_block_settings[models[i].id], year_week: year_week, exceptions: blueprint_block_setting_exceptions[models[i].id] });

                // Voor gesyncte omgevingen kan het voorkomen dat je een dienst hebt zonder setting. Omdat de setting alleen wordt meegestuurd van de dienst die uitbesteed wordt.
                if(!item && !_.is_empty(models[i].relation_id))
                    continue;

                item.title = customer_objects[item.customer_object_id].title;

                if(!_.is_empty(item.customer_object_project_id) && customer_object_projects[item.customer_object_project_id])
                    item.title = customer_object_projects[item.customer_object_project_id].title;
            }
            
            if(!item)
                continue;
            
            formatted_data.push(item);
        }

        return formatted_data;
    }
    
    get_field_props(settings) {
        let field_props = super.get_field_props(settings);

        // Zodat we visueel weergeven welke auto's wel en niet beschikbaar zijn.
        if(settings.field == 'vehicle_id' && !_.is_empty(field_props.options) && !_.is_empty(this.get_field_data('start_time')) && !_.is_empty(this.get_field_data('duration')))
        {
            field_props             = _.cloneDeep(field_props);
            let start_date          = (this.in_blueprint && this.get_field_data('start_date') <= moment().format('YYYY-MM-DD') ? moment().startOf('isoWeek').add(this.get_field_data('day'), 'days') : moment(this.get_field_data('start_date'))).format('YYYY-MM-DD');
            let year_week           = moment(start_date).format('GGGGWW');
            let start_date_time     = start_date + ' ' + this.get_field_data('start_time');
            let end_date_time       = moment(start_date_time).add({ minutes: _.time_to_minutes(this.get_field_data('duration')) }).format('YYYY-MM-DD HH:mm:ss');
            let shifts_with_vehicle = this.config.controller.get_data({models: [Components.__BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_ROUTE_COMPONENT__], models_object: 'array', filter_field: {date: {value: model => model.start_date <= start_date && _.if_empty(model.end_date, start_date) >= start_date}}, format: this._format_blueprint_data, after_format_filter: {vehicle_check: {value: model => {
                // Hij hoeft zichzelf niet mee te nemen.
                if(model.id == this.get_field_data((this.config.name == Components.__PLANNING_ROUTE_SETTING_EXCEPTION_COMPONENT__ || this.config.name == Components.__PLANNING_ROUTE_SETTING_COMPONENT__ ? 'route_id' : 'blueprint_block_id')) || _.is_empty(model.start_time) || _.is_empty(model.duration))
                    return false;
                
                let shift_start_date_time = moment(year_week, 'GGGGWW').add(model.day, 'days').format('YYYY-MM-DD') + ' ' + model.start_time;
                let shift_end_date_time   = moment(shift_start_date_time).add(_.time_to_minutes(model.duration), 'minutes').format('YYYY-MM-DD HH:mm:ss');

                return start_date_time < shift_end_date_time && end_date_time > shift_start_date_time && !_.is_empty(model.vehicle_id);
            }}}});
            
            let unavailable_vehicles = {};
            
            for(let i in shifts_with_vehicle)
                unavailable_vehicles[shifts_with_vehicle[i].vehicle_id] = shifts_with_vehicle[i].title + ' @ ' + _.get_time_format(shifts_with_vehicle[i].start_time) + ' - ' + _.add_minutes_to_time(shifts_with_vehicle[i].start_time, _.time_to_minutes(shifts_with_vehicle[i].duration));

            for(let i in field_props.options)
            {
                field_props.options[i].isDisabled = (unavailable_vehicles[field_props.options[i].value] ? true : false);
                
                if(field_props.options[i].isDisabled)
                    field_props.options[i].label += ' (' + unavailable_vehicles[field_props.options[i].value] + ')';
            }
        }

        return field_props;
    }
    
    check_values(settings) {
        super.check_values({...settings, ...{update: false}});

        const pauses                    = this.get_field_data('pauses');
        const deviating_invoice_time    = this.get_field_data('deviating_invoice_time');

        if(!_.is_empty(pauses))
        {
            let start_date_time = CustomDate.getCustomDateTime("2020-01-01 " + this.get_field_data('start_time'));
            let end_date_time   = CustomDate.getCustomDateTime("2020-01-01 " + this.get_field_data('start_time'));
            
            end_date_time.setMinutes(end_date_time.getMinutes() + _.time_to_minutes(this.get_field_data('duration')));

            for(let i in pauses)
            {
                if(_.is_empty(pauses[i]['start_time']) || _.is_empty(pauses[i]['end_time']))
                {
                    if(!_.is_empty(pauses[i]['start_time']))
                        this.errors['pause_stop'] = 'Dit veld is verplicht';
                    
                    if(!_.is_empty(pauses[i]['end_time']))
                        this.errors['pause_start'] = 'Dit veld is verplicht';

                    continue;
                }

                let pause_start_date_time   = CustomDate.getCustomDateTime("2020-01-01 " + pauses[i]['start_time']);
                let pause_end_date_time     = CustomDate.getCustomDateTime("2020-01-01 " + pauses[i]['end_time']);

                // pauze begint de volgende dag
                if(pauses[i]['start_time'] < _.get_time_format(this.get_field_data('start_time')))
                {
                    pause_start_date_time.setDate(pause_start_date_time.getDate() + 1);
                    pause_end_date_time.setDate(pause_end_date_time.getDate() + 1);
                }
                else if(pauses[i]['end_time'] < _.get_time_format(this.get_field_data('start_time')))
                    pause_end_date_time.setDate(pause_end_date_time.getDate() + 1);

                if(pause_start_date_time > end_date_time || pause_start_date_time < start_date_time)
                    this.errors['pause_start'] = 'Valt buiten dienst';
                else if(pause_start_date_time > pause_end_date_time)
                    this.errors['pause_start'] = 'Begint na einde';
                
                if(pause_end_date_time < start_date_time || pause_end_date_time > end_date_time)
                    this.errors['pause_stop'] = 'Valt buiten dienst';
                else if(pause_start_date_time > pause_end_date_time)
                    this.errors['pause_stop'] = 'Eindigt voor begin';
            }
        }

        if(!_.is_empty(deviating_invoice_time) && deviating_invoice_time.active == 't') {
            if(_.is_empty(deviating_invoice_time.start_time))
                this.errors['deviating_invoice_start_time'] = 'Dit veld is verplicht';
            
            if(_.is_empty(deviating_invoice_time.duration))
                this.errors['deviating_invoice_duration']   = 'Dit veld is verplicht';
            
            let pause_start;
            let pause_stop;
            
            if(!_.is_empty(pauses))
            {
                pause_start = pauses[0].start_time;
                pause_stop  = pauses[0].end_time;
            }
            
            if(!_.is_empty(deviating_invoice_time.pause_start))
                pause_start = deviating_invoice_time.pause_start;

            if(!_.is_empty(deviating_invoice_time.pause_stop))
                pause_stop = deviating_invoice_time.pause_stop;

            if((_.is_empty(pause_start) || _.is_empty(pause_stop)) && (!_.is_empty(pause_start) || !_.is_empty(pause_stop)))
            {
                if(_.is_empty(pause_start))
                    this.errors['deviating_invoice_pause_start'] = 'Dit veld is verplicht';
                
                if(_.is_empty(pause_stop))
                    this.errors['deviating_invoice_pause_stop'] = 'Dit veld is verplicht';
            }
            else
            {
                let start_date_time = CustomDate.getCustomDateTime("2020-01-01 " + (deviating_invoice_time.start_time || this.get_field_data('start_time')));
                let end_date_time   = CustomDate.getCustomDateTime("2020-01-01 " + (deviating_invoice_time.start_time || this.get_field_data('start_time')));
                
                end_date_time.setMinutes(end_date_time.getMinutes() + _.time_to_minutes(deviating_invoice_time.duration || this.get_field_data('duration')));

                let pause_start_date_time   = CustomDate.getCustomDateTime("2020-01-01 " + pause_start);
                let pause_end_date_time     = CustomDate.getCustomDateTime("2020-01-01 " + pause_stop);

                // pauze begint de volgende dag
                if(pause_start < _.get_time_format(deviating_invoice_time.start_time || this.get_field_data('start_time')))
                {
                    pause_start_date_time.setDate(pause_start_date_time.getDate() + 1);
                    pause_end_date_time.setDate(pause_end_date_time.getDate() + 1);
                }
                else if(pause_stop < _.get_time_format(deviating_invoice_time.start_time || this.get_field_data('start_time')))
                    pause_end_date_time.setDate(pause_end_date_time.getDate() + 1);

                if(pause_start_date_time > end_date_time || pause_start_date_time < start_date_time)
                    this.errors['deviating_invoice_pause_start'] = 'Valt buiten dienst';
                else if(pause_start_date_time > pause_end_date_time)
                    this.errors['deviating_invoice_pause_start'] = 'Begint na einde';
                
                if(pause_end_date_time < start_date_time || pause_end_date_time > end_date_time)
                    this.errors['deviating_invoice_pause_stop'] = 'Valt buiten dienst';
                else if(pause_start_date_time > pause_end_date_time)
                    this.errors['deviating_invoice_pause_stop'] = 'Eindigt voor begin';
            }
        }
        
        /// Voertuig check alleen doen op eenmalige dienst of uitzondering.
        if(((this.config.name == Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__ && this.get_field_data('start_date') == this.get_field_data('end_date')) || this.config.name == Components.__BLUEPRINT_BLOCK_SETTING_EXCEPTION_COMPONENT__ || this.config.name == Components.__PLANNING_ROUTE_SETTING_EXCEPTION_COMPONENT__) && !_.is_empty(this.get_field_data('vehicle_id')))
        {
            let year_week           = moment(this.get_field_data('start_date')).format('GGGGWW');
            let start_date_time     = this.get_field_data('start_date') + ' ' + this.get_field_data('start_time');
            let end_date_time       = moment(start_date_time).add({ minutes: _.time_to_minutes(this.get_field_data('duration')) }).format('YYYY-MM-DD HH:mm:ss');
            let shifts_with_vehicle = this.config.controller.get_data({models: [Components.__BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_ROUTE_COMPONENT__], models_object: 'array', filter_field: {date: {value: model => model.start_date <= this.get_field_data('start_date') && _.if_empty(model.end_date, this.get_field_data('start_date')) >= this.get_field_data('start_date')}}, format: this._format_blueprint_data, after_format_filter: {vehicle_check: {value: model => {
                // Zichzelf hoef je niet mee te nemen.
                if(model.id == this.get_field_data((this.config.name == Components.__PLANNING_ROUTE_SETTING_EXCEPTION_COMPONENT__ ? 'route_id' : 'blueprint_block_id')))
                    return false;
                
                let shift_start_date_time = moment(year_week, 'GGGGWW').add(model.day, 'days').format('YYYY-MM-DD') + ' ' + model.start_time;
                let shift_end_date_time   = moment(shift_start_date_time).add(_.time_to_minutes(model.duration), 'minutes').format('YYYY-MM-DD HH:mm:ss');

                return start_date_time < shift_end_date_time && end_date_time > shift_start_date_time && model.vehicle_id == this.get_field_data('vehicle_id');
            }}}, after_format_limit: 1});

            if(!_.is_empty(shifts_with_vehicle))
                this.errors['vehicle_id'] = 'Het opgegeven voertuig wordt op deze tijd al gebruikt voor de dienst: ' + shifts_with_vehicle.title + '.';
        }
    }
    
    get_changed_data() {
        let changed_data = super.get_changed_data();

        // Als hij geen start_date en end_date meegeeft in de blauwdruk gaat het in het commit script mis omdat hij geen periode kan vinden waarvoor hij eventuele concepten moet aanpassen
        if(this.has_data() && (this.name == Components.__BLUEPRINT_BLOCK_SETTING_COMPONENT__ || this.name == Components.__PLANNING_ROUTE_SETTING_COMPONENT__) && this.has_changes())
        {
            if(!changed_data.start_date)
                changed_data.start_date = this.get_field_data('start_date');
            
            if(!changed_data.end_date)
                changed_data.end_date = this.get_field_data('end_date');
        }
        
        return changed_data;
    }
}

export class BlueprintBlockSettingModel extends SettingModel {
    constructor(config) {
        super(config);

        this.relations.push({component: Components.__PLANNING_COMPONENT__, relation_field: 'blueprint_block_id', fields: ['start_time', 'duration', 'customer_contract_arrangement_id', 'report_template_ids', 'function_group_id'], model: BlueprintBlockPlanningModel});
        this.relations.push({component: Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__, relation_field: 'blueprint_block_id', fields: ['start_time', 'duration', 'customer_contract_arrangement_id', 'report_template_ids', 'function_group_id'], model: RoutePlanningTaskModel});
        
        this.fielddefines                                       = _.cloneDeep(this.fielddefines);
        this.fielddefines.on_location_checkpoint_id.mandatory   = (this.get_field_data('on_location_method') == 'Scanpunt' ? 't' : 'f');
        this.fielddefines.finish_checkpoint_id.mandatory        = (this.get_field_data('signing') == 'Scanpunt' ? 't' : 'f');
        this.fielddefines.report_template_ids.mandatory         = (this.get_field_data('report_mandatory') == 't' ? 't' : 'f');
    }
    
    set_field_data(settings) {
        if(settings.field == 'signing')
        {
            this.fielddefines.finish_checkpoint_id.mandatory = (settings.value == 'Scanpunt' ? 't' : 'f');
            
            if(settings.value != 'Scanpunt')
                super.set_field_data({ field: 'finish_checkpoint_id', value: null, trigger_after_field_change_update: false });
        }
        else if(settings.field == 'on_location_method')
        {
            this.fielddefines.on_location_checkpoint_id.mandatory = (settings.value == 'Scanpunt' ? 't' : 'f');
            
            if(settings.value != 'Scanpunt')
                super.set_field_data({ field: 'on_location_checkpoint_id', value: null, trigger_after_field_change_update: false });
        }
        else if(settings.field == 'start_time' && !_.is_empty(this.get_field_data('end_time')) && (_.is_empty(this.get_field_data('blueprint_block_id')) || !this.get_field_data('blueprint_block_id').toString().startsWith('new-')) && settings.currentDate < moment().format('YYYY-MM-DD'))
        {
            let durationValue;
            
            if (!_.is_empty(settings.value))
            {
                const endMinutes    = _.time_to_minutes(this.get_field_data('end_time'));
                const startMinutes  = _.time_to_minutes(settings.value);
                const diff          = endMinutes > startMinutes ? endMinutes - startMinutes : endMinutes + 24*60 - startMinutes;
                
                if(diff > _.time_to_minutes(this.get_field_data('duration')) * 1.5)
                    durationValue = this.get_field_data('duration');
                else
                    durationValue = _.minutes_to_time(diff) + ':00';
            }
            
            super.set_field_data({ field: 'duration', value: durationValue, trigger_after_field_change_update: false })
        }
        else if(settings.field == 'report_mandatory')
            this.fielddefines.report_template_ids.mandatory = (settings.value == 't' ? 't' : 'f');

        super.set_field_data(settings)
    }
    
    add_checkpoint_route(value) {
        let checkpoint_routes = _.cloneDeep(this.get_field_data('checkpoint_routes'));

        if(checkpoint_routes == null)
            checkpoint_routes = [];
        
        checkpoint_routes.push(value);
        
        this.set_field_data({field: 'checkpoint_routes', value: checkpoint_routes});
    }
    
    remove_checkpoint_route(index) {
        let checkpoint_routes = _.cloneDeep(this.get_field_data('checkpoint_routes'));

        if(checkpoint_routes == null)
            return;
        
        if(_.size(checkpoint_routes) == 1)
            checkpoint_routes = null;
        else
            checkpoint_routes.splice(index, 1);
        
        this.set_field_data({field: 'checkpoint_routes', value: checkpoint_routes});
    }
    
    add_travel_expense_route_node() {
        let travel_expense_route = _.cloneDeep(this.get_field_data('travel_expense_route'));

        if(travel_expense_route == null)
            travel_expense_route = [{title: 'Huisadres medewerker', latitude: null, longitude: null, compensate_distance: 't'}];
        
        travel_expense_route.push({title: '', latitude: null, longitude: null, compensate_distance: 't'});
        
        this.set_field_data({field: 'travel_expense_route', value: travel_expense_route});
    }
    
    remove_travel_expense_route_node(index) {
        let travel_expense_route = _.cloneDeep(this.get_field_data('travel_expense_route'));

        if(travel_expense_route == null)
            return;
        
        if(_.size(travel_expense_route) == 2)
            travel_expense_route = null;
        else
            travel_expense_route.splice(index, 1);
        
        this.set_field_data({field: 'travel_expense_route', value: travel_expense_route});
    }
    
    check_values(settings) {
        let has_errors = _.size(this.errors) > 0;
        
        super.check_values({...settings, ...{update: false}});
        
        if(!_.is_empty(this.get_field_data('customer_contract_arrangement_id')) && this.get_field_data('customer_contract_arrangement_id') != -1)
        {
            let customer_contract_arrangement_alternative   = this.config.controller.get_data({models: [Components.__CUSTOMER_CONTRACT_ARRANGEMENT_ALTERNATIVE_COMPONENT__], filter_field: {id: {value: this.get_field_data('customer_contract_arrangement_id')}}, limit: 1});
            let customer_contract_arrangement               = this.config.controller.get_data({models: [Components.__CUSTOMER_CONTRACT_ARRANGEMENT_COMPONENT__], filter_field: {id: {value: customer_contract_arrangement_alternative.customer_contract_arrangement_id}}, limit: 1});
            
            if(!_.is_value_in_set(customer_contract_arrangement.function_group_ids, this.get_field_data('function_group_id')))
                this.errors['customer_contract_arrangement_id'] = 'De gekozen alternatieve klant contract afspraak heeft niet dezelfde functiegroep';
        }

        if(has_errors || _.size(this.errors) > 0)
		    this.update();
    }
}

export class BlueprintBlockSettingExceptionModel extends BlueprintBlockSettingModel {
    reset(config)
    {
        config.name = Components.__BLUEPRINT_BLOCK_SETTING_EXCEPTION_COMPONENT__;

        if(config.get_data_from_state !== false)
        {
            config.get_data_from_state  = false; // Omdat we dat hieronder zelf al doen.
            let data                    = Planning.get_blueprint_block_data_for_date({ blueprint_block_id: config.data.blueprint_block_id, date: config.data.start_date, controller: config.controller, exceptions: {[config.data.blueprint_block_id]: {[config.data.start_date]: config.data}} });
            
            if(!_.is_empty(data))
            {
                delete data.id;
                
                // Vanuit de originele dienst gaan we de data opbouwen voor deze dienst.
                for(let i in data)
                    if(config.data[i] && !_.is_empty(data[i]) && _.is_empty(config.data[i]))
                        delete config.data[i];
            }
    
            config.data = {...data, ...{component_id: Components.__BLUEPRINT_BLOCK_SETTING_EXCEPTION_COMPONENT__, structure_id: 10084, fielddefine_id: 10184}, ...config.data};
        }
        
        super.reset(config);
    }
    
    set_field_data(settings) {
        settings = { ...settings };
        
        if(_.is_empty(settings.value))
        {
            if(settings.field == 'notification_check_setting_id' || settings.field == 'customer_contract_arrangement_id' || settings.field == 'company_location_id' || settings.field == 'customer_object_zone_id' || settings.field == 'customer_object_project_id' || settings.field == 'vehicle_id' || settings.field == 'report_template_ids' || settings.field == 'finish_checkpoint_id' || settings.field == 'on_location_checkpoint_id')
                settings.value = -31121985;
            else if(['pause_start', 'pause_stop'].includes(settings.field))
                settings.value = '';
            else if(!['deviating_invoice_start_time', 'deviating_invoice_duration', 'deviating_invoice_pause_start', 'deviating_invoice_pause_stop'].includes(settings.field))
                settings.value = '$_EMPTY_PLACEHOLDER_$';
        }
        
        super.set_field_data(settings);
    }
    
    get_field_data(field, default_value = null, show_original_value) {
        let value = super.get_field_data(field, default_value);
        
        if(!show_original_value && (value == '$_EMPTY_PLACEHOLDER_$' || value == -31121985))
            value = null;
        
        return value;
    }
    
    get_changed_data() {
        let data = super.get_changed_data();
        
        if(!_.is_empty(data))
        {
            let original_data = Planning.get_blueprint_block_setting_data_for_date({controller: this.config.controller, blueprint_block_id: this.get_field_data('blueprint_block_id'), date: this.get_field_data('start_date'), skip_exceptions: true});

            for(let field in data)
            {
                if(!_.is_empty(original_data[field]) && _.is_empty(data[field]))
                {
                    if(field == 'notification_check_setting_id' || field == 'customer_contract_arrangement_id' || field == 'company_location_id' || field == 'customer_object_zone_id' || field == 'customer_object_project_id' || field == 'vehicle_id' || field == 'report_template_ids' || settings.field == 'finish_checkpoint_id' || settings.field == 'on_location_checkpoint_id')
                        data[field] = -31121985;
                    else
                        data[field] = '$_EMPTY_PLACEHOLDER_$';
                }
                else if((_.isEqual(_.format_input(_.cloneDeep(this.get_field_data(field)), {format_numbers: false, nullify_empty_values: true}), _.format_input(_.cloneDeep(original_data[field]), {format_numbers: false, nullify_empty_values: true})) && _.includes(['component_id', 'id', 'fielddefine_id', 'structure_id'], field)))
                    delete data[field];
            }
            
            // Dit zijn geen changes, maar wel nodig in de database dus daarom sturen we ze alleen mee wanneer er nog andere changes zijn.
            data.blueprint_block_id = this.get_field_data('blueprint_block_id');
            data.start_date         = this.get_field_data('start_date');
            data.end_date           = this.get_field_data('end_date');
        }
        
        return data;
    }
    
    compare_changes(settings) {
        settings = { ...settings };
        
        if(!settings.changed_data)
        {
            let data                = _.omit(this.data, ['id', 'component_id', 'structure_id', 'start_date', 'end_date']);
            settings.changed_data   = {};
            
            for(let field in data)
            {
                if(_.is_empty(data[field]))
                    continue;
                
                if(data[field] == '$_EMPTY_PLACEHOLDER_$' || data[field] == -31121985)
                    data[field] = null;
                
                settings.changed_data[field] = data[field];
            }
        }
        
        return super.compare_changes(settings);
    }
    
    reset_data_to_state()
    {
        // Als hij niet in de state bestond, is het een nieuw record en kunnen we hem dus verwijderen.
        if(!this.exists_in_state())
            super.reset_data_to_state();
        else
        {
            let original_data   = Planning.get_blueprint_block_setting_data_for_date({controller: this.config.controller, blueprint_block_id: this.get_field_data('blueprint_block_id'), date: this.get_field_data('start_date'), skip_exceptions: true});
            let state_data      = _.cloneDeep(Planning.get_blueprint_block_setting_data_for_date({controller: this.config.controller, blueprint_block_id: this.get_field_data('blueprint_block_id'), date: this.get_field_data('start_date')}));
            let changed_fields  = [];
            this.changed_data   = {};
            this.errors         = {};

            state_data.id               = state_data.exception_id;
            state_data.component_id     = this.get_field_data('component_id');
            state_data.structure_id     = this.get_field_data('structure_id');
            state_data.fielddefine_id   = this.get_field_data('fielddefine_id');
            state_data.start_date       = this.get_field_data('start_date');
            state_data.end_date         = this.get_field_data('end_date');

            delete state_data.setting_id;
            delete state_data.exception_id;
            delete state_data.exception_date;
            delete state_data.setting_start_date;
            delete state_data.setting_end_date;

            // Als de original_data van de blauwdruk blok niet gelijk is aan de data uit de state, dan is er een aanpassing gedaan.
            for(let field in original_data)
            {
                if(!_.isEqual(_.format_input(_.cloneDeep(state_data[field]), {format_numbers: false, nullify_empty_values: true}), _.format_input(_.cloneDeep(original_data[field]), {format_numbers: false, nullify_empty_values: true})) && !_.includes(['component_id', 'blueprint_block_id', 'id', 'start_date', 'end_date', 'fielddefine_id', 'structure_id'], field))
                {
                    // Als de nieuwe waarde niet leeg is, of als hij wel leeg is, maar de originele waarde is niet leeg (dus er moet een placeholder komen)
                    if(!_.is_empty(state_data[field]) || !_.is_empty(original_data[field]))
                        changed_fields.push(field);
                }
            }

            for(let i in changed_fields)
            {
                if(!_.isEqual(_.format_input(_.cloneDeep(this.data[changed_fields[i]]), {format_numbers: false, nullify_empty_values: true}), _.format_input(_.cloneDeep(original_data[changed_fields[i]]), {format_numbers: false, nullify_empty_values: true})))
                    this.changed_data[changed_fields[i]] = true;
            }

            this.data = state_data;
        }
    }

    save_all_data()
    {
        // Omdat we alleen de gewijzigde waardes willen opslaan moeten we dit item op false zetten. Dan zal hij in de save van de controller alleen de changed data opslaan.
        return false;
    }
}

export class RouteModel extends PlannableModel {
    reset(config)
    {
        config.data = {...{structure_id: (config.name == Components.__PLANNING_ROUTE_COMPONENT__ ? 10062 : 10653), fielddefine_id: 10062}, ...config.data};

        super.reset(config);
    }
    
    get_settings(settings) {
        return Planning.get_route_data_for_date({controller: this.config.controller, route: this.data, date: settings.date});
    }
    
    is_plannable(settings) {
        if(!settings.data)
            settings.data = this.get_settings(settings);
        
        let messages = super.is_plannable({...settings, ...{relation_field: 'route_id'}});

        if(settings.remove_current)
            return messages;
        
        if(!settings.atw_only && _.is_empty(settings.data.relation_id))
        {
            let planned_shifts = this.config.controller.get_data({ models: [Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, Components.__SELF_SCHEDULE_PLANNING_COMPONENT__], models_object: 'array', filter_field: { route_id: { value: this.get_field_data('id') }, user_id: { value: -1, type: 'excludes' }, date: { value: model => _.get_date_format(model.start_date_time, true) == settings.date }, removed: {value: 't', type: 'excludes'} } });
    
            if(_.size(planned_shifts) == 1)
                messages[(settings.selfschedule ? 'errors' : 'warnings')].push('Wanneer je deze medewerker inplant, zal de dienst bezet zijn door meer mensen dan je hebt opgegeven.');
        }
        
        return messages;
    }

    plan(settings) {
        let data        = settings.data || this.get_settings(settings);
        settings        = {...{user_id: null, remove_current: _.is_empty(data.relation_id), show_messages: true, apply_data_to_state: true, selfschedule: false}, ...settings};
        let user_id     = settings.user_id || settings.user.id;
        let messages    = this.is_plannable({...(settings.user ? {user: settings.user} : {user_id: user_id}), date: settings.date, remove_current: settings.remove_current, selfschedule: settings.selfschedule, check_self_schedules: settings.check_self_schedules, atw_only: settings.atw_only, atw_should_give_error: settings.atw_should_give_error, ...(settings.data ? {data: settings.data} : {}), ...(settings.user_contract ? {user_contract: settings.user_contract} : {})});
        
        // bij de show_messages moeten we evengoed checken of er niet errors zijn, want bij errors mag je nooit inplannen.
        if((_.size(messages.errors) == 0 && _.size(messages.warnings) == 0) || (!settings.show_messages && _.size(messages.errors) == 0))
        {
            if(settings.remove_current)
                this.unplan({date: settings.date});

            let new_planning_model;

            if(settings.selfschedule)
            {
                new_planning_model = new SelfSchedulePlanningModel({controller: this.config.controller, data: {route_id: this.get_bind_id(), user_id: user_id, date: settings.date, period: settings.period}})
                
                new_planning_model.commit_changes({reset_start_data: false, reset_changed_data: false, apply_data_to_state: settings.apply_data_to_state});
                new_planning_model.save();
            }
            else
            {
                if(!_.is_empty(data.relation_id))
                {
                    new_planning_model = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_ROUTE_PLANNING_COMPONENT__], filter_field: {route_id: {value: this.get_field_data('id')}, date: {value: model => _.get_date_format(model.start_date_time, true) == settings.date, type: 'function'}, user_id: {value: -1}}, limit: 1}, models: {component_classes: RoutePlanningModel, limit: 1}});
    
                    // Dit mag eigenlijk nooit gebeuren, want is_plannable zou al een check moeten doen of je diegene nog wel kunt inplannen.
                    if(_.is_empty(new_planning_model))
                        return false;
    
                    new_planning_model.set_field_data({field: 'user_id', value: user_id});
                }
                else
                    new_planning_model = new RoutePlanningModel({controller: this.config.controller, data: {route_id: this.get_bind_id(), user_id: user_id, date: settings.date, component_id: Components.__PLANNING_ROUTE_PLANNING_COMPONENT__}});

                if(settings.creator_id)
                    new_planning_model.set_field_data({field: 'creator_id', value: settings.creator_id});

                new_planning_model.commit_changes({reset_start_data: false, reset_changed_data: false, apply_data_to_state: settings.apply_data_to_state});
                
                // Als het om een nieuwe planning gaat moeten we de onderliggende items ook aanmaken.
                if(!new_planning_model.has_data())
                    new_planning_model.create_route_planning_items({remove_current: settings.remove_current, apply_data_to_state: settings.apply_data_to_state});
            
                // Als er een eenmalige uitzonderig op een vaste planning was voor deze medewerker op deze dienst kan hier weer weggehaald worden aangezien de medewerker weer opnieuw wordt ingepland op de dienst waar hij eerst eenmalig uitgepland was
                let recurring_user_exception_model = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_RECURRING_USER_EXCEPTION_COMPONENT__], filter_field: {user_id: {value: user_id}, route_id: {value: this.get_bind_id()}, start_year_week: {value: new CustomDate(_.get_date_format(settings.date, true)).getYearWeek()}, removed: {value: 't', type: 'excludes'}}}, models: {limit: 1}});
                
                if(!_.is_empty(recurring_user_exception_model))
                {
                    recurring_user_exception_model.remove();
                    recurring_user_exception_model.commit_changes({reset_start_data: false, reset_changed_data: false});
                }
            }

            // We moeten ook naar de dag van gisteren kijken. Want de dienst die vandaag wordt ingepland kan invloed hebben op een roostervrije dag van gisteren. Dit omdat de rusttijd van gisteren wordt aangepast als je vandaag een dienst inplant.
            let yesterday = new CustomDate(settings.date);
            
            yesterday.setDate(yesterday.getDate() - 1);

            let planning_user_unavailability_schedule_free_models = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_USER_UNAVAILABILITY_SCHEDULE_FREE_COMPONENT__], filter_field: {user_id: {value: settings.user_id}, removed: {value: 't', type: 'excludes'}, date_check: {type: 'function', value: model => (_.get_date_format(model.start_date_time, true) == yesterday.getYearMonthDay() || _.get_date_format(model.start_date_time, true) == _.get_date_format(new_planning_model.get_field_data('start_date_time'), true) || _.get_date_format(model.start_date_time, true) == _.get_date_format(new_planning_model.get_field_data('end_date_time'), true))}}}, models: {component_classes: PlanningUserAvailabilityScheduleFreeModel}});

            if(!_.is_empty(planning_user_unavailability_schedule_free_models))
                for(let i in planning_user_unavailability_schedule_free_models)
                {
                    if(
                        // Als hij op dezelfde dag start moet hij altijd verwijderd worden.
                        settings.date == _.get_date_format(planning_user_unavailability_schedule_free_models[i].get_field_data('start_date_time'))
                        ||
                        // Als hij niet op dezelfde dag start moeten we kijken of de dag van de roostervrije registratie nogsteeds een vrije dag is.
                        !Planning.is_free_day({date: _.get_date_format(planning_user_unavailability_schedule_free_models[i].get_field_data('start_date_time'), true), controller: this.config.controller, user_id: user_id})
                    )
                    {
                        planning_user_unavailability_schedule_free_models[i].remove();
                        planning_user_unavailability_schedule_free_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
                    }
                }
            
            if(!settings.ignore_open_offer_check)
            {
                let open_planning_models = this.config.controller.get_models_from_data({data: {models: [Components.__OPEN_PLANNING_COMPONENT__], filter_field: {route_id: {value: this.get_bind_id()}, date: {value: settings.date}}}});
                    
                if(!_.is_empty(open_planning_models))
                {
                    for(let i in open_planning_models)
                        open_planning_models[i].remove();
                    
                    this.config.controller.save({url: Config.SERVER_REQUEST_URL + '?ajax_id=37&component=' + Components.__OPEN_PLANNING_COMPONENT__ + '&form-action=edit', models: {[Components.__OPEN_PLANNING_COMPONENT__]: open_planning_models}}).then(resp => this.check_open_offers(settings));
                }
                else
                    this.check_open_offers(settings);
            }
            else
            {
                let related_models = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_OFFER_COMPONENT__, Components.__OPEN_PLANNING_COMPONENT__], models_object: 'array', filter_field: {route_id: {value: this.get_bind_id()}, user_id: {value: user_id}, date: { value: settings.date }, state: {value: ['Afgewezen'], type: 'excludes'}, removed: {value: 't', type: 'excludes'}}}, models: {return_models_split_components: false, keep_keys: false}});

                for(let i in related_models)
                {
                    related_models[i].remove();
                    related_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
                }
            }

            if(this.config.controller.component.state.selected_item && this.config.controller.component.state.selected_item.type != 'copy' && (this.config.controller.component.state.selected_item.component_id == Components.__PLANNING_ROUTE_COMPONENT__ || this.config.controller.component.state.selected_item.component_id == Components.__PLANNING_SINGLE_ROUTE_COMPONENT__))
            {
                this.config.controller.component.setState({selected_item: null});
                
                // Omdat hij anders het model nutteloos laat staan, waardoor het lijkt of er een change zit
                if(!this.has_changes())
                    this.remove({force: true});
            }

            return true;
        }
        else if(_.size(messages.errors) > 0 && settings.show_messages)
            this.config.controller.component.setState({messageTitle: 'Let op', messageContent: messages.errors});
        else if(_.size(messages.warnings) > 0 && settings.show_messages)
        {
            messages.warnings.push('');
            messages.warnings.push('Weet je zeker dat je deze medewerker evengoed wilt inplannen?');
            this.config.controller.component.setState({messageTitle: 'Let op', messageContent: messages.warnings, messageConfirmCallback: this.plan.bind(this), ...(settings.success_callback ? {messageCloseCallback: settings.success_callback} : {}), messageConfirmCallbackParams: {...settings, ...{show_messages: false}}});
        }

        return false;
    }
    
    check_open_offers(settings) {
        let planning_offers = this.config.controller.get_data({models: [Components.__PLANNING_OFFER_COMPONENT__], filter_field: {route_id: {value: this.get_bind_id()}, date: {value: settings.date}, state: {value: ['Aangeboden', 'Ingeschreven'], type: 'includes_desc'}}});

        if(!_.is_empty(planning_offers))
            this.config.controller.component.setState({messageTitle: 'Deze route is nog aangeboden', messageContent: ['', 'Wil je de openstaande aanbiedingen van de zojuist ingeplande routes intrekken? Als je dit niet doet blijven ze open staan en kunnen mensen er nog op reageren.'], messageConfirmCallback: this.remove_open_offers.bind(this), messageCloseCallback: () => {}, messageConfirmCallbackParams: settings});
    }
    
    remove_open_offers(settings) {
        let current_planned_users   = this.config.controller.get_data({ models: [Components.__PLANNING_ROUTE_PLANNING_TASK_COMPONENT__], filter_field: { route_id: { value: this.get_field_data('id') }, user_id: { value: -1, type: 'excludes' }, date: { value: model => _.get_date_format(model.start_date_time, true) == settings.date }, removed: {value: 't', type: 'excludes'} }, format: 'asGrouped', key: 'user_id' });
        let planning_offer_models   = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_OFFER_COMPONENT__], filter_field: {route_id: {value: this.get_bind_id()}, date: {value: settings.date}, state: {value: ['Aangeboden', 'Ingeschreven'], type: 'includes_desc'}}}});

        for(let i in planning_offer_models)
        {
            // current_planned_users check, want als iemand ingepland is hoeven we de aangeboden dienst niet op ingetrokken te zetten, want diegene is ingepland. Dan kunnen we de aangeboden dienst dus gewoon verwijderen.
            if(planning_offer_models[i].get_field_data('state') == 'Ingeschreven' && !current_planned_users[planning_offer_models[i].get_field_data('user_id')])
            {
                planning_offer_models[i].set_field_data({field: 'state', value: 'Ingetrokken'});
                planning_offer_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
            }
            else
                planning_offer_models[i].remove();
        }
        
        this.config.controller.save({url: Config.SERVER_REQUEST_URL + '?ajax_id=37&component=' + Components.__PLANNING_OFFER_COMPONENT__ + '&form-action=edit', models: {[Components.__PLANNING_OFFER_COMPONENT__]: planning_offer_models}});
    }
    
    cancel(settings) {
        // Dienst eerst volledig uitplannen
        this.unplan(settings);
        
        // Geannuleerde registratie aanmaken
        let model = new RoutePlanningModel({controller: this.config.controller, data: {route_id: this.get_bind_id(), user_id: -1, state: 'Geannuleerd', date: settings.date, component_id: Components.__PLANNING_ROUTE_PLANNING_COMPONENT__}});

        model.commit_changes({reset_start_data: false, reset_changed_data: false});
        
        // Aangeboden diensten die nog open staan kunnen ook verwijderd worden.
        let offers = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_OFFER_COMPONENT__], filter_field: {route_id: {value: this.get_field_data('id')}, removed: {value: 't', type: 'excludes'}, state: {value: 'Aangeboden'}}}});
        
        if(!_.is_empty(offers))
            for(let i in offers)
            {
                offers[i].remove();
                offers[i].commit_changes({reset_start_data: false, reset_changed_data: false});
            }
    }
    
    reopen(settings) {
        settings = {...{}, ...settings};
        
        let planning_models = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_ROUTE_PLANNING_COMPONENT__], filter_field: {route_id: {value: this.get_bind_id()}, date: {type: 'function', value: model => settings.date == _.get_date_format(model.start_date_time, true)}}}, models: {component_classes: RoutePlanningModel}});
        
        for(let i in planning_models)
        {
            planning_models[i].remove();
            planning_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
        }
        
        //Mocht je hem perongeluk hebben geannuleerd en je heropent hem weer voordat je gepubliceerd hebt moeten we de offers die we verwijderd hadden in de cancel functie weer undo-en
        let offers = this.config.controller.get_models({models: [Components.__PLANNING_OFFER_COMPONENT__, Components.__OPEN_PLANNING_COMPONENT__], models_object: 'array', return_models_split_components: false, keep_keys: false, filter_field: {route_id: {value: this.get_field_data('id')}, state: {value: 'Aangeboden'}}});
        
        if(!_.is_empty(offers))
            for(let i in offers)
                offers[i].undo_changes();
    }
    
    unplan(settings) {
        settings            = {...{cancel: false}, ...settings};
        let planning_items  = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_ROUTE_PLANNING_COMPONENT__], filter_field: {route_id: {value: this.get_bind_id()}, date: {type: 'function', value: model => _.get_date_format(model.start_date_time, true) == settings.date}, removed: {value: 't', type: 'excludes'}}}, models: {component_classes: RoutePlanningModel}});
        
        if(_.size(planning_items) == 0)
            return false;
        
        for(let i in planning_items)
            planning_items[i].unplan(settings);
    }
    
    remove_with_check(settings) {
        let success = () => {
            this.remove(settings);
            this.commit_changes({reset_start_data: false, reset_changed_data: false});
        }

        // Als het niet een eenmalige dienst is moeten we gewoon de super class aanroepen
        if(this.get_field_data('structure_id') != 10653)
            return success();

        let current_planning = this.config.controller.get_data({models: [Components.__PLANNING_ROUTE_PLANNING_COMPONENT__], filter_field: {route_id: {value: this.get_bind_id()}, removed: {value: 't', type: 'excludes'}, user_id: {value: -1, type: 'excludes'}}});
        
        if(_.size(current_planning) == 0)
            return success();

        this.config.controller.component.setState({messageTitle: 'Let op', messageContent: ['Deze dienst staat nog ingepland op een medewerker. Als je hem verwijdert wordt de medewerker ook uitgepland.', '', 'Weet je zeker dat je dit wilt doen?'], messageConfirmCallback: success.bind(this)});
    }
    
    remove(settings) {
        settings = {...{}, ...settings};
        
        // Anders krijgen we een error omdat het item niet meer bestaat.
        if(this.config.controller.component.state.selected_item && this.config.controller.component.state.selected_item.component_id == Components.__PLANNING_SINGLE_ROUTE_COMPONENT__ && this.config.controller.component.state.selected_item.id == this.get_field_data('id'))
            this.config.controller.component.setState({selected_item: null});

        // Geen force change, want als we alleen de route willen verwijderen moet niet ook al de rest verwijderd worden.
        if(this.get_field_data('structure_id') == 10653 && !settings.force)
        {
            let blueprint_blocks        = Planning.get_route_blueprint_blocks_for_date({controller: this.config.controller, route: this.data, date: new CustomDate(this.data.start_date)});
            let blueprint_block_models  = {};
            
            if(!_.is_empty(blueprint_blocks))
                blueprint_block_models = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_BLUEPRINT_BLOCK_COMPONENT__], filter_field: {id: {value: _.map(blueprint_blocks, 'id'), type: 'includes_desc'}, removed: {value: 't', type: 'excludes'}}}, models: {component_classes: BlueprintBlockModel}});
            
            let related_models = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_OFFER_COMPONENT__, Components.__OPEN_PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__, Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__, Components.__PLANNING_ROUTE_SETTING_COMPONENT__, Components.__PLANNING_ROUTE_SETTING_EXCEPTION_COMPONENT__, Components.__SHIFT_NOTE_COMPONENT__], models_object: 'array', filter_field: {route_id: {value: this.get_bind_id()}, removed: {value: 't', type: 'excludes'}}}, models: {return_models_split_components: false, keep_keys: false, component_classes: {[Components.__PLANNING_ROUTE_PLANNING_COMPONENT__]: RoutePlanningModel}}});

            for(let i in related_models)
            {
                // Als je een vaste dienst in een tijdelijke route hebt geplaatst moet die niet verwijderd worden wanneer de eenmalige route verwijderd wordt. Dit moet natuurlijk alleen als ze normaal gesproken in een vaste route zitten. Anders wordt de dienst in 1 keer teruggezet in de originele route zonder dat de planner daar weet van heeft.
                if(related_models[i].config.name == Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_EXCEPTION_COMPONENT__ && !blueprint_block_models[related_models[i].get_field_data('blueprint_block_id')] && Planning.is_blueprint_block_in_route_for_yearweek({controller: this.config.controller, blueprint_block_id: related_models[i].get_field_data('blueprint_block_id'), year_week: related_models[i].get_field_data('start_year_week'), skip_exceptions: true}).route_id != -1)
                    related_models[i].set_field_data({field: 'route_id', value: -1});
                else
                    related_models[i].remove();

                related_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
            }

            if(!_.is_empty(blueprint_block_models))
                for(let i in blueprint_block_models)
                {
                    blueprint_block_models[i].remove();
                    blueprint_block_models[i].commit_changes({reset_start_data: false, reset_changed_data: false});
                }
        }
        
        return super.remove(settings);
    }
}

export class RouteSettingModel extends SettingModel {
    constructor(config) {
        super(config);

        this.relations.push({component: Components.__PLANNING_ROUTE_PLANNING_COMPONENT__, relation_field: 'route_id', fields: ['start_time', 'duration', 'customer_id', 'report_template_ids'], model: RoutePlanningModel});
    }
    
    get_field_data(field, default_value = null) {
        if(field == 'day')
        {
            let route = this.config.controller.get_data_and_models({models: [Components.__PLANNING_ROUTE_COMPONENT__, Components.__PLANNING_SINGLE_ROUTE_COMPONENT__], filter_field: {id: {value: this.get_field_data('route_id')}}, limit: 1});

            return route.day;
        }

        return super.get_field_data(field, default_value);
    }
    
    set_field_data(settings) {
        if(settings.field == 'start_time' && !_.is_empty(this.get_field_data('end_time')) && (_.is_empty(this.get_field_data('route_id')) || !this.get_field_data('route_id').toString().startsWith('new-')) && settings.currentDate < moment().format('YYYY-MM-DD'))
        {
            let durationValue;
            
            if (!_.is_empty(settings.value))
            {
                const endMinutes    = _.time_to_minutes(this.get_field_data('end_time'));
                const startMinutes  = _.time_to_minutes(settings.value);
                const diff          = endMinutes > startMinutes ? endMinutes - startMinutes : endMinutes + 24*60 - startMinutes;
                
                if(diff > _.time_to_minutes(this.get_field_data('duration')) * 1.5)
                    durationValue = this.get_field_data('duration');
                else
                    durationValue = _.minutes_to_time(diff) + ':00';
            }
            
            super.set_field_data({ field: 'duration', value: durationValue, trigger_after_field_change_update: false })
        }
        super.set_field_data(settings)
    }
    
    compare_changes(settings) {
        let properties              = super.compare_changes(settings);
        let route_blueprint_blocks  = this.config.controller.get_models({models: [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__], filter_field: {route_id: {value: this.get_field_data('route_id')}}});

        if(!_.is_empty(route_blueprint_blocks))
        {
            let customer_objects                    = this.config.controller.get_data({models: [Components.__CUSTOMER_OBJECT_COMPONENT__], format: 'asGrouped', key: 'id'});
            properties['route_blueprint_blocks']    = { label: 'Diensten', records: [], old_records: []};
            
            for(let i in route_blueprint_blocks)
            {
                let blueprint_block = Planning.get_blueprint_block_data_for_date({blueprint_block_id: route_blueprint_blocks[i].get_field_data('blueprint_block_id'), controller: this.config.controller, year_week: _.if_empty(route_blueprint_blocks[i].get_field_data('end_year_week'), route_blueprint_blocks[i].get_field_data('start_year_week'))});
                let data            = {value: _.get_time_format(blueprint_block.start_time) + ' - ' + _.add_minutes_to_time(blueprint_block.start_time, _.time_to_minutes(blueprint_block.duration)) + ' | ' + customer_objects[blueprint_block.customer_object_id].title};
                
                if(!_.is_empty(route_blueprint_blocks[i].get_field_data('end_year_week')) || route_blueprint_blocks[i].get_field_data('removed') == 't')
                    properties['route_blueprint_blocks'].old_records.push(data);
                else
                    properties['route_blueprint_blocks'].records.push(data);
            }
        }

        return properties;
    }
    
    has_changes() {
        if(super.has_changes())
            return true;
        
        // Zodat hij in de blauwdruk een change ziet wanneer er diensten aan een route zijn toegevoegd.
        let route_blueprint_blocks = this.config.controller.get_models({models: [Components.__PLANNING_ROUTE_BLUEPRINT_BLOCK_COMPONENT__], filter_field: {route_id: {value: this.get_field_data('route_id')}, start_year_week: {value: moment(this.get_field_data('start_date')).format('GGGGWW'), type: '>='}}});

        return !_.is_empty(route_blueprint_blocks);
    }
    
    check_values(settings) {
        let has_errors = _.size(this.errors) > 0;
        
        super.check_values({...settings, ...{update: false}});

        if(has_errors || _.size(this.errors) > 0)
		    this.update();
    }
}

export class RouteSettingExceptionModel extends RouteSettingModel {
    reset(config)
    {
        config.name = Components.__PLANNING_ROUTE_SETTING_EXCEPTION_COMPONENT__;
        
        if(config.get_data_from_state !== false)
        {
            config.get_data_from_state  = false; // Omdat we dat hieronder zelf al doen.
            let data                    = Planning.get_route_data_for_date({ route_id: config.data.route_id, date: config.data.start_date, controller: config.controller, exceptions: {[config.data.route_id]: {[config.data.start_date]: config.data}} });
            
            if(!_.is_empty(data))
            {
                delete data.id;
                
                // Vanuit de originele dienst gaan we de data opbouwen voor deze dienst.
                for(let i in data)
                    if(config.data[i] && !_.is_empty(data[i]) && _.is_empty(config.data[i]))
                        delete config.data[i];
            }
    
            config.data = {...data, ...{component_id: Components.__PLANNING_ROUTE_SETTING_EXCEPTION_COMPONENT__, structure_id: 10084, fielddefine_id: 10184}, ...config.data};
        }
        
        super.reset(config);
    }
    
    set_field_data(settings) {
        settings = { ...settings };
        
        if(_.is_empty(settings.value))
        {
            if(settings.field == 'customer_id' || settings.field == 'notification_check_setting_id' || settings.field == 'company_location_id' || settings.field == 'vehicle_id' || settings.field == 'report_template_ids')
                settings.value = -31121985;
            else if(settings.field == 'pause_start' || settings.field == 'pause_stop')
                settings.value = '';
            else
                settings.value = '$_EMPTY_PLACEHOLDER_$';
        }
        
        super.set_field_data(settings);
    }
    
    get_field_data(field, default_value = null, show_original_value) {
        let value = super.get_field_data(field, default_value);
        
        if(!show_original_value && (value == '$_EMPTY_PLACEHOLDER_$' || value == -31121985))
            value = null;
        
        return value;
    }
    
    get_changed_data() {
        let data = super.get_changed_data();
        
        if(!_.is_empty(data))
        {
            let original_data = Planning.get_route_settings_data_for_date({controller: this.config.controller, route_id: this.get_field_data('route_id'), date: this.get_field_data('start_date'), skip_exceptions: true});

            for(let field in data)
            {
                if(!_.is_empty(original_data[field]) && _.is_empty(data[field]))
                {
                    if(settings.field == 'customer_id' || settings.field == 'notification_check_setting_id' || settings.field == 'company_location_id' || settings.field == 'vehicle_id' || settings.field == 'report_template_ids')
                        data[field] = -31121985
                    else
                        data[field] = '$_EMPTY_PLACEHOLDER_$';
                }
                else if((_.isEqual(_.format_input(_.cloneDeep(this.get_field_data(field)), {format_numbers: false, nullify_empty_values: true}), _.format_input(_.cloneDeep(original_data[field]), {format_numbers: false, nullify_empty_values: true})) && _.includes(['component_id', 'id', 'fielddefine_id', 'structure_id'], field)))
                    delete data[field];
            }

            // Dit zijn geen changes, maar wel nodig in de database dus daarom sturen we ze alleen mee wanneer er nog andere changes zijn.
            data.route_id   = this.get_field_data('route_id');
            data.start_date = this.get_field_data('start_date');
            data.end_date   = this.get_field_data('end_date');
        }
        
        return data;
    }
    
    compare_changes(settings) {
        settings = { ...settings };
        
        if(!settings.changed_data)
        {
            let data                = _.omit(this.data, ['id', 'component_id', 'structure_id', 'start_date', 'end_date']);
            settings.changed_data   = {};
            
            for(let field in data)
            {
                if(_.is_empty(data[field]))
                    continue;
                
                if(data[field] == '$_EMPTY_PLACEHOLDER_$' || data[field] == -31121985)
                    data[field] = null;
                
                settings.changed_data[field] = data[field];
            }
        }
        
        return super.compare_changes(settings);
    }
    
    reset_data_to_state()
    {
        // Als hij niet in de state bestond, is het een nieuw record en kunnen we hem dus verwijderen.
        if(!this.exists_in_state())
            super.reset_data_to_state();
        else
        {
            let original_data   = Planning.get_route_settings_data_for_date({controller: this.config.controller, route_id: this.get_field_data('route_id'), date: this.get_field_data('start_date'), skip_exceptions: true});
            let state_data      = _.cloneDeep(Planning.get_route_settings_data_for_date({controller: this.config.controller, route_id: this.get_field_data('route_id'), date: this.get_field_data('start_date')}));
            let changed_fields  = [];
            this.changed_data   = {};
            this.errors         = {};

            state_data.id               = state_data.exception_id;
            state_data.component_id     = this.get_field_data('component_id');
            state_data.structure_id     = this.get_field_data('structure_id');
            state_data.fielddefine_id   = this.get_field_data('fielddefine_id');
            state_data.start_date       = this.get_field_data('start_date');
            state_data.end_date         = this.get_field_data('end_date');

            delete state_data.setting_id;
            delete state_data.exception_id;
            delete state_data.exception_date;
            delete state_data.setting_start_date;
            delete state_data.setting_end_date;

            // Als de original_data van de blauwdruk blok niet gelijk is aan de data uit de state, dan is er een aanpassing gedaan.
            for(let field in original_data)
            {
                if(!_.isEqual(_.format_input(_.cloneDeep(state_data[field]), {format_numbers: false, nullify_empty_values: true}), _.format_input(_.cloneDeep(original_data[field]), {format_numbers: false, nullify_empty_values: true})) && !_.includes(['component_id', 'route_id', 'id', 'start_date', 'end_date', 'fielddefine_id', 'structure_id'], field))
                {
                    // Als de nieuwe waarde niet leeg is, of als hij wel leeg is, maar de originele waarde is niet leeg (dus er moet een placeholder komen)
                    if(!_.is_empty(state_data[field]) || !_.is_empty(original_data[field]))
                        changed_fields.push(field);
                }
            }

            for(let i in changed_fields)
            {
                if(!_.isEqual(_.format_input(_.cloneDeep(this.data[changed_fields[i]]), {format_numbers: false, nullify_empty_values: true}), _.format_input(_.cloneDeep(original_data[changed_fields[i]]), {format_numbers: false, nullify_empty_values: true})))
                    this.changed_data[changed_fields[i]] = true;
            }

            this.data = state_data;
        }
    }

    save_all_data()
    {
        // Omdat we alleen de gewijzigde waardes willen opslaan moeten we dit item op false zetten. Dan zal hij in de save van de controller alleen de changed data opslaan.
        return false;
    }
}

export class RouteRandomShiftSettingModel extends SettingModel {
    constructor(config) {
        super(config);

        // this.relations.push({component: Components.__PLANNING_COMPONENT__, relation_field: 'blueprint_block_id', fields: ['start_time', 'duration', 'customer_contract_arrangement_id', 'report_template_ids', 'function_group_id'], model: BlueprintBlockPlanningModel});
        
        this.fielddefines                               = _.cloneDeep(this.fielddefines);
        this.fielddefines.report_template_ids.mandatory = (this.get_field_data('report_mandatory') == 't' ? 't' : 'f');
    }
    
    reset(config)
    {
        config.name = Components.__PLANNING_ROUTE_RANDOM_SHIFT_SETTING_COMPONENT__;
        
        super.reset(config);
    }
    
    set_field_data(settings) {
        if(settings.field == 'report_mandatory')
            this.fielddefines.report_template_ids.mandatory = (settings.value == 't' ? 't' : 'f');

        super.set_field_data(settings)
    }
    
    check_values(settings) {
        let has_errors = _.size(this.errors) > 0;
        
        super.check_values({ ...settings, ...{ update: false } });
        
        // update setting staat standaard op false in de SettingModel class. Daarom doen we de update hier handmatig.
        if(has_errors || _.size(this.errors) > 0)
		    this.update();
    }
}

export class BlueprintBlockTemplateModel extends SettingModel {
    reset(config)
    {
        config.name = Components.__BLUEPRINT_BLOCK_TEMPLATE_COMPONENT__;
        
        super.reset(config);
    }
    
    // Template heeft geen relaties.
    set_relation_data() {}
    
    check_values(settings) {
        const has_errors = _.size(this.errors) > 0;
        
        super.check_values({ ...settings, ...{ update: false } });

        if(has_errors || _.size(this.errors) > 0)
		    this.update();
    }
}

export class PlanningUserAvailabilityScheduleFreeModel extends Model {
    plan()
    {
        // let filter_field        = {user_id: {value: this.get_field_data('user_id')}, removed: {value: 't', type: 'excludes'}, time: {type: 'function', value: model => {
        //     let data = (model instanceof Model ? model.data : model);

        //     return (_.get_date_format(data.start_date_time, true) == _.get_date_format(this.get_field_data('start_date_time'), true) || (_.get_time_format(data.end_date_time) != '00:00' && _.get_date_format(data.end_date_time, true) == _.get_date_format(this.get_field_data('start_date_time'), true)));
        // }}};
        // let current_planning    = this.config.controller.get_models_from_data({data: {models: [Components.__PLANNING_TIME_PERIOD_COMPONENT__, Components.__PLANNING_COMPONENT__, Components.__PLANNING_ROUTE_PLANNING_COMPONENT__], filter_field: filter_field}, models: {component_classes: {[Components.__PLANNING_TIME_PERIOD_COMPONENT__]: TimePeriodPlanningModel, [Components.__PLANNING_COMPONENT__]: BlueprintBlockPlanningModel, [Components.__PLANNING_ROUTE_PLANNING_COMPONENT__]: RoutePlanningModel}}});
        
        // if(!_.is_empty(current_planning))
        //     for(let i in current_planning)
        //     {
        //         current_planning[i].remove();
        //         current_planning[i].commit_changes({reset_start_data: false, reset_changed_data: false});
        //     }

        this.commit_changes({reset_start_data: false, reset_changed_data: false});
    }
}